// HavJoy shape print masks v1
/* Shared polygon print boundary. The server exports the same alpha mask. */
(function () {
  'use strict';
  const exports = new Map();
  function path(mask, width, height) {
    const p = new Path2D();
    [mask.points, ...(mask.holes || [])].forEach(points => {
      points.forEach((v, i) => i ? p.lineTo(v[0]*width,v[1]*height) : p.moveTo(v[0]*width,v[1]*height));
      p.closePath();
    });
    return p;
  }
  function forArea(mask, area) {
    if (!mask || !mask.bounds || !area) return mask;
    const b=mask.bounds;
    const project=points=>points.map(p=>[(b.x+p[0]*b.w-area.x)/area.w,(b.y+p[1]*b.h-area.y)/area.h]);
    return {...mask, points:project(mask.points), holes:(mask.holes||[]).map(project)};
  }
  function apply(canvas, mask) {
    if (!mask) return canvas;
    const alpha=document.createElement('canvas');alpha.width=canvas.width;alpha.height=canvas.height;
    const context=alpha.getContext('2d');context.fill(path({points:mask.points},canvas.width,canvas.height));
    context.globalCompositeOperation='destination-out';
    (mask.holes || []).forEach(points=>context.fill(path({points},canvas.width,canvas.height)));
    const target=canvas.getContext('2d');target.save();target.globalCompositeOperation='destination-in';target.drawImage(alpha,0,0);target.restore();
    return canvas;
  }
  function copy(canvas, mask) {
    const result=document.createElement('canvas');result.width=canvas.width;result.height=canvas.height;
    result.getContext('2d').drawImage(canvas,0,0);return apply(result,mask);
  }
  function register(url, urls) { exports.set(url, urls || {}); }
  function artworkUrl(url, mockup) {
    if (!mockup || !mockup.print_mask) return url;
    const result=(exports.get(url)||{})[mockup.sourceMockupKey || mockup.key];
    if (typeof result !== 'string' || !result.startsWith('https://')) throw new Error('Shape print file is unavailable. Generate the Design again.');
    return result;
  }
  function cartProperties(props, url, mockup) {
    if (!mockup || !mockup.print_mask) return props;
    return {...props, your_design:artworkUrl(url,mockup), _shape_print_files:JSON.stringify(exports.get(url))};
  }
  function outline(host, mask) {
    host.querySelectorAll('[data-print-mask-outline]').forEach(n=>n.remove());
    if (!mask) return;
    const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');svg.setAttribute('viewBox','0 0 1000 1000');svg.setAttribute('preserveAspectRatio','none');
    svg.dataset.printMaskOutline='';svg.style.cssText='position:absolute;inset:0;width:100%;height:100%;pointer-events:none;overflow:visible';
    const boundary=document.createElementNS(svg.namespaceURI,'path');
    boundary.setAttribute('d',[mask.points,...(mask.holes||[])].map(points=>points.map((p,i)=>(i?'L':'M')+(p[0]*1000)+','+(p[1]*1000)).join(' ')+'Z').join(' '));
    boundary.setAttribute('fill','none');boundary.setAttribute('stroke','#0d9488');boundary.setAttribute('stroke-width','2');boundary.setAttribute('vector-effect','non-scaling-stroke');boundary.setAttribute('stroke-dasharray','6 4');
    svg.appendChild(boundary);host.appendChild(svg);
  }
  window.HavjoyPrintMask={apply,copy,register,artworkUrl,cartProperties,outline,forArea};
})();

// HavJoy Ceramic Ornament shape support v1
// HavJoy configurable multi-photo v1
/* Reuses tee-template-multi-photo's hj-multi-upload tile, remove/add and count UI. */
(function () {
  'use strict';
  function create(options) {
    function setting(owner) { return owner && owner.template && owner.template.photoUpload || {}; }
    function enabled(owner) { return setting(owner).multiple === true; }
    function field(owner) { return owner.template.slots.find(function (s) { return s.type === 'image'; }); }
    var storageKey = 'havjoy_multi_photo_uploads_v1';
    function restore(owner) {
      if (!enabled(owner) || !field(owner) || owner.multiPhotos) return;
      var value = owner.values[field(owner).key];
      var urls = Array.isArray(value) ? value : value ? [value] : [];
      if (!urls.length) {
        try {
          var saved = window.localStorage.getItem(storageKey);
          if (saved !== null) {
            urls = JSON.parse(saved);
          } else {
            var recent = JSON.parse(window.localStorage.getItem('havjoy_recent_uploads') || '[]');
            var rows = Array.isArray(recent) ? recent.filter(function (row) { return row && Array.isArray(row.urls); }) : [];
            var row = rows.find(function (item) { return item.primary !== false; }) || rows[0];
            urls = row ? row.urls : [];
          }
        } catch (error) { urls = []; }
      }
      urls = (Array.isArray(urls) ? urls : []).filter(function (url, index, all) {
        return typeof url === 'string' && /^https?:\/\//i.test(url) && all.indexOf(url) === index;
      }).slice(0, setting(owner).max);
      owner.values[field(owner).key] = urls;
      owner.multiPhotos = urls.map(function (url) { return { url: url, preview: url, status: 'ready' }; });
      owner.photoPreviewUrl = urls[0] || '';
      if (options.preloadPhoto) urls.forEach(options.preloadPhoto);
    }

    function items(owner) {
      if (!owner.multiPhotos) {
        var value = owner.values[field(owner).key];
        owner.multiPhotos = (Array.isArray(value) ? value : value ? [value] : []).map(function (url) {
          return {url:url, preview:url, status:'ready'};
        });
      }
      return owner.multiPhotos;
    }
    function message(owner) {
      if (!enabled(owner)) return '';
      var photos=items(owner), cfg=setting(owner);
      if (photos.some(function (p) { return p.status==='uploading'; })) return 'Please wait for your photos to finish uploading.';
      if (photos.some(function (p) { return p.status==='failed'; })) return 'Retry or remove the photo that could not upload.';
      if (photos.length < cfg.min) return 'Please upload at least ' + cfg.min + ' photos.';
      if (photos.length > cfg.max) return 'You can upload up to ' + cfg.max + ' photos.';
      return '';
    }
    function changed(owner) {
      var photos=items(owner);
      owner.values[field(owner).key]=photos.filter(function(p){return p.status==='ready';}).map(function(p){return p.url;});
      owner.photoPreviewUrl=photos.length ? photos[0].preview : '';
      if (!photos.some(function (photo) { return photo.status === 'uploading'; })) {
        try {
          window.localStorage.setItem(storageKey, JSON.stringify(owner.values[field(owner).key]));
        } catch (error) { /* Uploads remain usable when storage is unavailable. */ }
      }
      options.changed(owner);
    }
    async function upload(owner, photo) {
      photo.status='uploading';owner.uploadsInFlight++;
      changed(owner);
      try {
        var result=await options.upload(photo.file);
        if (photo.removed) return;
        URL.revokeObjectURL(photo.preview);
        photo.url=result.url;photo.preview=result.url;photo.status='ready';
      } catch (error) {
        if (!photo.removed) photo.status='failed';
      } finally {
        owner.uploadsInFlight=Math.max(0,owner.uploadsInFlight-1);
        changed(owner);
      }
    }
    function add(owner, files) {
      var photos=items(owner), cfg=setting(owner), incoming=Array.from(files || []);
      if (photos.length+incoming.length > cfg.max) { options.error('You can upload up to '+cfg.max+' photos.');return; }
      if (incoming.some(function(f){return owner.template.upload.types.indexOf(options.mime(f))<0 || f.size>owner.template.upload.maxBytes;})) {
        options.error('Choose supported images within the upload size limit.');return;
      }
      var added=incoming.map(function(file){return {file:file,preview:URL.createObjectURL(file),status:'uploading'};});
      photos.push.apply(photos,added);
      added.forEach(function(photo){upload(owner,photo);});
    }
    function remove(owner, photo) {
      photo.removed=true;
      if (photo.preview.indexOf('blob:')===0) URL.revokeObjectURL(photo.preview);
      owner.multiPhotos=items(owner).filter(function(p){return p!==photo;});changed(owner);
    }
    function render(owner, picker, grid, reuse) {
      if (!enabled(owner)) return false;
      var photos=items(owner),cfg=setting(owner);
      picker.classList.remove('hj-multi-upload--single');grid.classList.remove('hj-multi-upload__grid--single');
      picker.setAttribute('data-multi-photo-picker','');grid.setAttribute('data-multi-photo-grid','');
      var head=picker.querySelector('.hj-multi-upload__head');
      head.hidden=photos.length>0;head.querySelector('p').textContent='Add '+cfg.min+'–'+cfg.max+' photos';
      if(reuse)reuse.hidden=true;
      grid.replaceChildren();
      photos.forEach(function(photo,index){
        var tile=document.createElement('div');tile.className='hj-multi-upload__tile';
        options.renderPhoto(tile,photo.preview,'Uploaded photo '+(index+1));
        var close=document.createElement('button');close.type='button';close.className='hj-multi-upload__remove';close.textContent='×';close.setAttribute('aria-label','Remove photo '+(index+1));close.setAttribute('data-help-vi','Xóa ảnh này khỏi lần tạo Design. Các ảnh khác được giữ nguyên.');
        close.addEventListener('click',function(){remove(owner,photo);});tile.appendChild(close);
        if(photo.status==='failed'){
          var retry=document.createElement('button');retry.type='button';retry.textContent='Retry';retry.setAttribute('data-help-vi','Tải lại ảnh bị lỗi. Các ảnh khác được giữ nguyên.');
          retry.addEventListener('click',function(){upload(owner,photo);});tile.appendChild(retry);
        }
        if(photo.status==='uploading')tile.setAttribute('aria-busy','true');
        grid.appendChild(tile);
      });
      if(photos.length<cfg.max){
        var addButton=document.createElement('button');addButton.type='button';addButton.className='hj-multi-upload__tile hj-multi-upload__add';
        addButton.innerHTML='<span class="hj-multi-upload__add-icon">+</span><span>Add photo</span>';
        addButton.setAttribute('data-help-vi','Chọn thêm ảnh cho cùng Design, tối đa theo giới hạn của Product.');addButton.addEventListener('click',options.pick);grid.appendChild(addButton);
      }
      var count=picker.querySelector('[data-multi-photo-count]');
      if(!count){count=document.createElement('div');count.className='hj-multi-upload__count';count.setAttribute('data-multi-photo-count','');count.setAttribute('role','status');picker.appendChild(count);}
      count.hidden=false;
      count.setAttribute('data-help-vi','Tất cả ảnh phải tải xong và đủ số lượng tối thiểu trước khi tạo Design.');
      count.textContent=photos.length+' / '+cfg.max+' photos · '+(message(owner)||'Ready to preview');
      return true;
    }
    return {enabled:enabled,message:message,add:add,render:render,restore:restore};
  }
  window.HavjoyMultiPhoto={create:create};
})();

// HavJoy multiple mockup gallery integration v1
/* HavJoy mockup gallery v1: variant identity is independent of photograph/pose. */
(function () {
  'use strict';
  function token(value) { return String(value || '').trim().toLowerCase().replace(/[\s-]+/g, '_'); }
  function type(value) {
    var key = token(value);
    return ({t_shirt:'tshirt',tshirt:'tshirt',hoodie:'hoodie',sweatshirt:'sweatshirt',tank_top:'tanktop',tanktop:'tanktop',washed_tee:'washed_tee',washed_tshirt:'washed_tee'})[key] || '';
  }
  function ornamentShape(item) {
    var legacy = /^ceramic_(heart|round|star)_white(?:__variant_\d+)?$/.exec(item.sourceMockupKey || item.key || '');
    return item.product_family === 'ceramic_ornament' && item.shape ? token(item.shape) : legacy ? legacy[1] : '';
  }
  function identity(item, side) {
    var shape = ornamentShape(item);
    if (shape) {
      var ceramicSide = item.print_side || side || 'front';
      return {type:'ceramic_ornament', color:'white', side:ceramicSide, key:'ceramic_ornament:' + shape + ':' + ceramicSide};
    }
    var parts = String(item.variantName || item.variant_name || '').split('/');
    var explicit = !!(item.garment_type || item.garment_color);
    var garment = type(explicit ? item.garment_type : (parts.length <= 2 ? parts[0] : ''));
    var color = token(explicit ? item.garment_color : (parts.length === 2 ? parts[1] : ''));
    var printSide = item.print_side || side || 'front';
    return {type:garment, color:color, side:printSide, key:garment && color ? garment + ':' + color + ':' + printSide : 'legacy:' + item.key + ':' + printSide};
  }
  function group(template, product, variant) {
    if (!template || !variant || !Array.isArray(variant.options)) return [];
    var names = (product && product.options) || [];
    function value(name) {
      var index = names.findIndex(function (n) { return token(typeof n === 'string' ? n : n.name) === name; });
      return index < 0 ? '' : variant.options[index];
    }
    var shape = token(value('shape'));
    if (shape) {
      return template.mockups.filter(function (m) {
        return ornamentShape(m) === shape
          && (m.print_side || template.printSide || 'front') === (template.printSide || 'front');
      });
    }
    var garment = type(value('product_type')), color = token(value('color'));
    var matches = template.mockups.filter(function (m) {
      var id = identity(m, template.printSide);
      return id.side === (template.printSide || 'front') && id.type === garment && (!color || id.color === color);
    });
    if (!matches.length && garment === 'washed_tee' && color === 'black') {
      matches = template.mockups.filter(function (m) { var id=identity(m,template.printSide);return id.type===garment && id.color==='mineral_black' && id.side===(template.printSide || 'front'); });
    }
    if (!matches.length && !color && !garment) {
      var fallback = template.mockups.find(function (m) { return m.key === template.defaultMockupKey; });
      if (fallback) matches = template.mockups.filter(function (m) { return identity(m,template.printSide).key === identity(fallback,template.printSide).key; });
    }
    if (matches.length && !color) {
      var anchor = matches.find(function(m){return m.key===template.defaultMockupKey;}) || matches[0];
      matches=matches.filter(function(m){return identity(m,template.printSide).key===identity(anchor,template.printSide).key;});
    }
    return matches.sort(function (a, b) {
      var first = a.mockup_order == null ? Number.MAX_SAFE_INTEGER : Number(a.mockup_order);
      var second = b.mockup_order == null ? Number.MAX_SAFE_INTEGER : Number(b.mockup_order);
      return (Number.isFinite(first) ? first : Number.MAX_SAFE_INTEGER) -
        (Number.isFinite(second) ? second : Number.MAX_SAFE_INTEGER);
    });
  }
  function withVariantBackgrounds(template, product) {
    if (template && template.mockups.some(function(m){return !!ornamentShape(m);})) return template;
    if (!template || !product || !Array.isArray(product.variants)) return template;
    var result = [], handled = {};
    template.mockups.forEach(function (source) {
      var identityKey = identity(source, template.printSide).key;
      if (handled[identityKey]) return;
      var images = [];
      product.variants.forEach(function (variant) {
        var image = variant.featuredImage;
        if (!image || group(template, product, variant).indexOf(source) === -1) return;
        if (!images.some(function (entry) { return entry.src === image.src; })) images.push(image);
      });
      if (!images.length) {
        if (!product.variantBackgroundOnly) result.push(source);
        return;
      }
      handled[identityKey] = true;
      images.forEach(function (image, index) {
        result.push(Object.assign({}, source, {
          key: index === 0 ? source.key : source.key + '__variant_' + index,
          sourceMockupKey: source.key,
          variantBackground: image,
          mockup_group_key: identityKey,
          mockup_order: index,
          overlay: null
        }));
      });
    });
    var originalDefault = template.mockups.find(function (item) { return item.key === template.defaultMockupKey; });
    template.variantBackgroundOnly = !!product.variantBackgroundOnly;
    template.mockups = result;
    template.mockupKeys = result.map(function (item) { return item.key; });
    if (template.mockupKeys.indexOf(template.defaultMockupKey) === -1 && originalDefault) {
      var replacement = result.find(function (item) { return identity(item, template.printSide).key === identity(originalDefault, template.printSide).key; });
      if (replacement) template.defaultMockupKey = replacement.key;
    }
    return template;
  }
  function choose(owner, product, variant) {
    var rows = group(owner.template, product, variant);
    if (owner.template && owner.template.variantBackgroundOnly && (!variant || !variant.featuredImage || !rows.some(function(m) {
      return m.variantBackground && m.variantBackground.src === variant.featuredImage.src;
    }))) return null;
    var signature = rows.map(function (m) { return m.key; }).join('|');
    var variantImage = variant && variant.featuredImage && variant.featuredImage.src || '';
    if (owner.galleryGroup !== signature || owner.galleryVariantImage !== variantImage) {
      owner.galleryGroup = signature;
      owner.galleryVariantImage = variantImage;
      var preferred = rows.find(function(m) { return m.variantBackground && m.variantBackground.src === variantImage; }) || rows[0];
      owner.galleryKey = preferred && preferred.key;
    }
    return rows.find(function (m) { return m.key === owner.galleryKey; }) || rows[0] || null;
  }
  function adjacent(owner, product, variant) {
    var selected = choose(owner, product, variant), rows = group(owner.template, product, variant);
    var index = rows.indexOf(selected);
    return index >= 0 ? rows[index + 1] || null : null;
  }
  function mount(host, surface, getState, onChoose, onRetry) {
    if (!host || !surface) return {render:function(){}};
    var bar = document.createElement('div');bar.className='hj-mockup-slider';
    bar.setAttribute('role','group');bar.setAttribute('aria-label','Mockup images');
    bar.setAttribute('data-help-vi', 'Vuốt hoặc chọn ảnh để xem cùng Design trên các Mockup của sản phẩm đã chọn.');
    if (getComputedStyle(host).position === 'static') host.style.position='relative';
    bar.style.cssText='display:flex;position:absolute;inset:0;min-height:44px;z-index:2;pointer-events:none;box-sizing:border-box';
    host.appendChild(bar);
    function button(label, action) {
      var b=document.createElement('button');b.type='button';b.textContent=label;
      if (label === 'previous' || label === 'next') {
        b.innerHTML='<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="'+(label === 'previous' ? 'M20 12H4m7-7-7 7 7 7' : 'M4 12h16m-7-7 7 7-7 7')+'"/></svg>';
      }
      b.style.cssText='min-width:40px;min-height:40px;border:1px solid #ddd;border-radius:20px;background:rgba(255,255,255,.94);color:#222;padding:4px 10px;cursor:pointer;pointer-events:auto;position:absolute;box-shadow:0 2px 8px rgba(0,0,0,.12)';
      b.addEventListener('click',action);bar.appendChild(b);return b;
    }
    var previous=button('previous',function(){move(-1);});previous.setAttribute('aria-label','Previous');previous.style.cssText+=';left:12px;top:50%;transform:translateY(-50%)';
    var next=button('next',function(){move(1);});next.setAttribute('aria-label','Next');next.style.cssText+=';right:12px;top:50%;transform:translateY(-50%)';
    var retry=button('Retry',function(){onRetry();});retry.style.cssText+=';bottom:48px;left:50%;transform:translateX(-50%)';retry.setAttribute('data-help-vi', 'Tải lại ảnh Mockup đang chọn. Không tạo lại Design.');
    function move(delta) {
      var s=getState(),index=s.rows.findIndex(function(m){return m.key===s.key;});
      if (index+delta>=0 && index+delta<s.rows.length) onChoose(s.rows[index+delta].key);
    }
    var start=null;
    surface.style.touchAction='pan-y';
    surface.addEventListener('touchstart',function(e){if(e.touches.length===1)start={x:e.touches[0].clientX,y:e.touches[0].clientY};},{passive:true});
    surface.addEventListener('touchend',function(e){
      if(!start||!e.changedTouches.length)return;
      var dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;start=null;
      if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.5)move(dx<0?1:-1);
    },{passive:true});
    surface.addEventListener('touchcancel',function(){start=null;},{passive:true});
    function render() {
      var s=getState();var index=s.rows.findIndex(function(m){return m.key===s.key;});
      bar.style.display=s.rows.length>1||s.error?'flex':'none';
      previous.hidden=next.hidden=s.rows.length<=1;
      previous.disabled=index<=0;next.disabled=index<0||index>=s.rows.length-1;
      previous.style.opacity=previous.disabled?'.4':'1';next.style.opacity=next.disabled?'.4':'1';
      retry.hidden=!s.error;
    }
    return {render:render};
  }
  window.HavjoyMockupGallery={identity:identity,group:group,choose:choose,adjacent:adjacent,mount:mount,withVariantBackgrounds:withVariantBackgrounds};
})();

// HavJoy single-side session metadata v1
(function () {
  'use strict';

  var API_BASE_URL = 'https://api.havjoy.com';
  // Upload preparation and finalization use the same API host.
  var UPLOAD_PREPARE_API_BASE_URL = 'https://api.havjoy.com';
  var TEMPLATE_API_BASE_URL = 'https://api.havjoy.com';
  var GENERATION_API_BASE_URL = 'https://api.havjoy.com';
  var JOB_STATUS_API_BASE_URL = GENERATION_API_BASE_URL;
  var SHOPIFY_UPLOAD_API_BASE_URL = UPLOAD_PREPARE_API_BASE_URL;
  var TEMPLATE_TIMEOUT_MS = 8000;
  var REQUEST_TIMEOUT_MS = 60000;
  var SUBMIT_LOST_LOCK_MS = 60000;
  var POLL_TIMEOUT_MS = 10 * 60 * 1000;
  var CUSTOMER_IMAGE_MAX_INPUT_BYTES = 15 * 1024 * 1024;
  var CUSTOMER_IMAGE_MAX_DIMENSION = 1024;
  var CUSTOMER_IMAGE_JPEG_QUALITY = 0.85;
  var DEFAULT_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];
  var RECENT_UPLOADS_STORAGE_KEY = 'havjoy_recent_uploads';
  var RECENT_UPLOADS_MAX_ITEMS = 20;
  var CUSTOMER_PHOTO_PROMISE_CACHE = {};
  var HEIC_CONVERTER_PROMISE = null;

  function saveRecentUploadedUrl(url, isPrimary) {
    if (typeof url !== 'string' || !url) return;
    try {
      var rows = JSON.parse(window.localStorage.getItem(RECENT_UPLOADS_STORAGE_KEY) || '[]');
      if (!Array.isArray(rows)) rows = [];
      rows = rows.filter(function (item) {
        return !isObject(item) || !Array.isArray(item.urls) || item.urls.indexOf(url) === -1;
      });
      rows.unshift({ urls: [url], savedAt: new Date().toISOString(), primary: isPrimary !== false });
      window.localStorage.setItem(RECENT_UPLOADS_STORAGE_KEY, JSON.stringify(rows.slice(0, RECENT_UPLOADS_MAX_ITEMS)));
      window.dispatchEvent(new CustomEvent('havjoy:recent-upload-updated', { detail: { url: url } }));
    } catch (error) {
      console.warn('[HavJoy] Could not save uploaded image URL', error);
    }
  }

  function readLatestUploadedUrl() {
    try {
      var rows = JSON.parse(window.localStorage.getItem(RECENT_UPLOADS_STORAGE_KEY) || '[]');
      if (!Array.isArray(rows)) return '';
      var fallback = '';
      for (var index = 0; index < rows.length; index += 1) {
        var item = rows[index];
        var urls = isObject(item) && Array.isArray(item.urls) ? item.urls : [];
        var url = urls.find(function (value) { return typeof value === 'string' && /^https?:\/\//i.test(value); }) || '';
        if (!url) continue;
        if (!fallback) fallback = url;
        if (item.primary !== false) return url;
      }
      return fallback;
    } catch (error) {
      return '';
    }
  }

  function isObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
  }

  function normalizeMockupVariantName(value) {
    return String(value || '').trim().toLowerCase().replace(/[\s_-]+/g, ' ');
  }

  function resolveVariantMockup(template, product, variant) {
    var rows = window.HavjoyMockupGallery.group(template, product, variant);
    var image = variant && variant.featuredImage;
    return rows.find(function (mockup) {
      return image && (mockup.variantBackground ? mockup.variantBackground.src : mockup.templateUrl) === image.src;
    }) || (template && template.variantBackgroundOnly ? null : rows[0]) || null;
  }

  function parseJsonElement(id) {
    var element = document.getElementById(id);
    if (!element) return null;
    try { return JSON.parse(element.textContent || '{}'); }
    catch (error) { return null; }
  }

  function fetchWithTimeout(url, options, timeoutMs) {
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, timeoutMs);
    return fetch(url, Object.assign({}, options || {}, { signal: controller.signal }))
      .finally(function () { window.clearTimeout(timer); });
  }

  function wait(ms) {
    return new Promise(function (resolve) { window.setTimeout(resolve, ms); });
  }

  function logGenerationTiming(label, sessionId, startedAt, status, progress) {
    var elapsedSeconds = ((performance.now() - startedAt) / 1000).toFixed(1);
    var progressText = Number.isFinite(Number(progress)) ? ' | progress ' + Number(progress) + '%' : '';
    console.info('[HavJoy] ' + label + ' | ' + sessionId + ' | ' + status + ' | ' + elapsedSeconds + 's' + progressText);
  }

  function applyTshirtVariousMockups(template, mockups, canvas, contract) {
    return window.HavjoyDesignPreview.applyPlacement(template, mockups, canvas, contract);
  }

  function loadCustomerPhoto(url) {
    var cacheKey = url;
    if (CUSTOMER_PHOTO_PROMISE_CACHE[cacheKey]) return CUSTOMER_PHOTO_PROMISE_CACHE[cacheKey];
    var promise = new Promise(function (resolve, reject) {
      var image = new Image();
      var timer = window.setTimeout(function () {
        delete CUSTOMER_PHOTO_PROMISE_CACHE[cacheKey];
        reject(new Error('Customer photo timed out'));
      }, 30000);
      // Customer photos are displayed directly; no canvas access is needed.
      image.onload = function () {
        Promise.resolve().then(function () { return typeof image.decode === 'function' ? image.decode() : null; })
          .then(function () { window.clearTimeout(timer); resolve(image); }, image.onerror);
      };
      image.onerror = function () {
        window.clearTimeout(timer);
        delete CUSTOMER_PHOTO_PROMISE_CACHE[cacheKey];
        reject(new Error('Could not load customer photo'));
      };
      image.src = url;
    });
    CUSTOMER_PHOTO_PROMISE_CACHE[cacheKey] = promise;
    return promise;
  }

  function renderUploadPhoto(tile, url, alt) {
    var preview = document.createElement('div');
    preview.className = 'hjv2-upload-preview';
    var status = document.createElement('span');
    status.className = 'hjv2-upload-preview__status';
    status.setAttribute('role', 'status');
    var retry = document.createElement('button');
    retry.type = 'button';
    retry.textContent = 'Retry loading photo';
    retry.hidden = true;
    preview.appendChild(status);
    preview.appendChild(retry);
    tile.appendChild(preview);
    function load() {
      preview.dataset.photoState = 'loading';
      preview.setAttribute('aria-busy', 'true');
      status.textContent = 'Loading your photo…';
      retry.hidden = true;
      loadCustomerPhoto(url).then(function (cached) {
        var image = cached.cloneNode(false);
        image.alt = alt;
        preview.appendChild(image);
        preview.dataset.photoState = 'ready';
        preview.removeAttribute('aria-busy');
        status.textContent = '';
        status.hidden = true;
      }).catch(function () {
        preview.dataset.photoState = 'error';
        preview.removeAttribute('aria-busy');
        status.textContent = 'Could not load this photo. Retry or choose another photo.';
        retry.hidden = false;
      });
    }
    retry.addEventListener('click', function (event) { event.stopPropagation(); load(); });
    load();
  }

  async function loadPersonalizationTemplate(handle, product) {
    var path = '/api/personalization-template?product=' + encodeURIComponent(handle);
    var options = { method: 'GET', headers: { Accept: 'application/json' } };
    var response = await fetchWithTimeout(TEMPLATE_API_BASE_URL + path, options, TEMPLATE_TIMEOUT_MS);
    if (!response.ok) throw new Error('Template unavailable');
    var payload = await response.json();
    if (!isObject(payload)) throw new Error('Invalid template');
    var photo = payload.photo_upload;
    if (!isObject(photo) || typeof photo.multiple !== 'boolean' ||
        !Number.isInteger(photo.min) || !Number.isInteger(photo.max) ||
        photo.min < 0 || photo.max < 1 || photo.min > photo.max ||
        (!photo.multiple && photo.max !== 1) || ['front', 'back'].indexOf(payload.print_side) === -1) {
      throw new Error('Personalization settings are missing or invalid. Please try again later.');
    }
    var template = normalizeTemplate(payload);
    if (!template) throw new Error('Invalid template');
    return window.HavjoyMockupGallery.withVariantBackgrounds(template, product);
  }

  function normalizeTemplate(payload) {
    if (!isObject(payload)) return null;
    const validTemplate =
      payload.success &&
      payload.template_id &&
      Array.isArray(payload.slots) &&
      Array.isArray(payload.mockups);
    if (!validTemplate) return null;
    var raw = payload;
    if (raw.print_side !== undefined && raw.print_side !== "front" && raw.print_side !== "back") return null;
    if (!Array.isArray(raw.slots) || !Array.isArray(raw.mockups) || !raw.mockups.length) return null;
    if (!isObject(raw.upload)) return null;
    if (!Array.isArray(raw.upload.types) || !Number.isInteger(raw.upload.max_bytes) || raw.upload.max_bytes < 1) return null;

    var mockupKeys = [];
    var mockups = [];
    raw.mockups.forEach(function (mockup) {
      if (
        isObject(mockup) &&
        typeof mockup.key === 'string' &&
        mockup.key &&
        typeof mockup.variant_name === 'string' &&
        mockupKeys.indexOf(mockup.key) === -1
      ) {
        var printArea = mockup.print_area;
        var printX = isObject(printArea) ? Number(printArea.x) : NaN;
        var printY = isObject(printArea) ? Number(printArea.y) : NaN;
        var printW = isObject(printArea) ? Number(printArea.w) : NaN;
        var printH = isObject(printArea) ? Number(printArea.h) : NaN;
        var printRotation = isObject(printArea) && printArea.rotation != null ? Number(printArea.rotation) : 0;
        var templateUrl = typeof mockup.url === 'string' ? mockup.url.trim() : '';
        var templateWidth = Number(mockup.width);
        var templateHeight = Number(mockup.height);
        var templateGarmentScale = mockup.garment_scale == null ? 1 : Number(mockup.garment_scale);
        if (
          ![printX, printY, printW, printH, printRotation].every(Number.isFinite) || Math.abs(printRotation) > 180 ||
          printX < 0 || printY < 0 || printW <= 0 || printH <= 0 ||
          printX + printW > 1 || printY + printH > 1 ||
          (!/^https:\/\//i.test(templateUrl) && mockup.render_type !== 'ceramic_3d') ||
          !Number.isFinite(templateWidth) || templateWidth <= 0 ||
          !Number.isFinite(templateHeight) || templateHeight <= 0 ||
          !Number.isFinite(templateGarmentScale) ||
          templateGarmentScale < 0.5 || templateGarmentScale > 2.5
        ) return;
        mockupKeys.push(mockup.key);
        mockups.push({
          key: mockup.key,
          variantName: mockup.variant_name,
          product_family: mockup.product_family,
          shape: mockup.shape,
          print_mask: mockup.print_mask,
          color: mockup.color,
          garment_type: mockup.garment_type,
          garment_color: mockup.garment_color,
          print_side: mockup.print_side || raw.print_side || 'front',
          mockup_group_key: mockup.mockup_group_key,
          mockup_order: mockup.mockup_order,
          templateUrl: templateUrl,
          templateWidth: templateWidth,
          templateHeight: templateHeight,
          templateGarmentScale: templateGarmentScale,
          templatePrintArea: { x: printX, y: printY, w: printW, h: printH, rotation: printRotation },
          overlay: null
        });
      }
    });
    if (mockupKeys.length !== raw.mockups.length) return null;
    if (typeof raw.default_mockup_key !== 'string' || mockupKeys.indexOf(raw.default_mockup_key) === -1) return null;

    var slotKeys = [];
    var slots = [];
    for (var index = 0; index < raw.slots.length; index += 1) {
      var slot = raw.slots[index];
      if (!isObject(slot) || typeof slot.key !== 'string' || !slot.key || slotKeys.indexOf(slot.key) !== -1) return null;
      var type = slot.type === 'image' ? 'image' : ((slot.type === 'text' || slot.binding === 'prompt') ? 'text' : null);
      if (!type) return null;
      var minLength = slot.min_length == null ? null : Number(slot.min_length);
      var maxLength = slot.max_length == null ? null : Number(slot.max_length);
      if (minLength !== null && (!Number.isInteger(minLength) || minLength < 0)) return null;
      if (maxLength !== null && (!Number.isInteger(maxLength) || maxLength < 1)) return null;
      if (minLength !== null && maxLength !== null && minLength > maxLength) return null;
      slotKeys.push(slot.key);
      slots.push({
        key: slot.key,
        type: type,
        label: typeof slot.label === 'string' && slot.label ? slot.label : slot.key,
        helpVi: typeof slot.help_vi === 'string' ? slot.help_vi : '',
        required: slot.required === true,
        minLength: minLength,
        maxLength: maxLength,
        inputType: slot.input_type === 'text_with_suggestions' ? 'text_with_suggestions' : 'text',
        placeholder: typeof slot.placeholder === 'string' ? slot.placeholder : '',
        suggestions: Array.isArray(slot.suggestions) ? slot.suggestions.filter(function (value, index, all) {
          return typeof value === 'string' && value.trim() && all.indexOf(value) === index;
        }) : []
      });
    }

    var uploadTypes = raw.upload.types.length ? raw.upload.types.map(function (type) {
      return typeof type === 'string' ? type.toLowerCase() : '';
    }) : DEFAULT_IMAGE_TYPES.slice();
    if (!uploadTypes.length || uploadTypes.some(function (type) { return type.indexOf('image/') !== 0; })) return null;

    return {
      photoUploadKnown: isObject(raw.photo_upload) && typeof raw.photo_upload.multiple === 'boolean',
      photoUpload: raw.photo_upload || {multiple:false,min:1,max:1},
      templateId: raw.template_id,
      printSide: raw.print_side === undefined ? "front" : raw.print_side,
      slots: slots,
      mockups: mockups,
      mockupKeys: mockupKeys,
      defaultMockupKey: raw.default_mockup_key,
      upload: { types: uploadTypes, maxBytes: Math.min(raw.upload.max_bytes, CUSTOMER_IMAGE_MAX_INPUT_BYTES) }
    };
  }

  function inferMime(file) {
    if (file.type) return file.type.toLowerCase();
    var extension = (file.name.split('.').pop() || '').toLowerCase();
    return {
      jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp',
      heic: 'image/heic', heif: 'image/heif'
    }[extension] || '';
  }

  function isHeicFile(file) {
    var type = String(file && file.type || '').toLowerCase();
    var name = String(file && file.name || '');
    return type.indexOf('heic') !== -1 || type.indexOf('heif') !== -1 || /\.(heic|heif)$/i.test(name);
  }

  function ensureHeicConverter() {
    if (typeof window.heic2any === 'function') return Promise.resolve(window.heic2any);
    if (HEIC_CONVERTER_PROMISE) return HEIC_CONVERTER_PROMISE;
    HEIC_CONVERTER_PROMISE = new Promise(function (resolve, reject) {
      var source = window.HavjoyHeic2anyUrl;
      if (!source) {
        reject(new Error('HEIC converter is not available'));
        return;
      }
      var script = document.createElement('script');
      script.src = source;
      script.async = true;
      script.onload = function () {
        if (typeof window.heic2any === 'function') resolve(window.heic2any);
        else reject(new Error('HEIC converter could not be loaded'));
      };
      script.onerror = function () { reject(new Error('HEIC converter could not be loaded')); };
      document.head.appendChild(script);
    }).catch(function (error) {
      HEIC_CONVERTER_PROMISE = null;
      throw error;
    });
    return HEIC_CONVERTER_PROMISE;
  }

  function loadCustomerImage(blob) {
    return new Promise(function (resolve, reject) {
      var objectUrl = URL.createObjectURL(blob);
      var image = new Image();
      image.onload = function () {
        URL.revokeObjectURL(objectUrl);
        resolve(image);
      };
      image.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('The selected image cannot be decoded'));
      };
      image.src = objectUrl;
    });
  }

  function customerCanvasToJpeg(canvas) {
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (blob) resolve(blob);
        else reject(new Error('JPEG encoding failed'));
      }, 'image/jpeg', CUSTOMER_IMAGE_JPEG_QUALITY);
    });
  }

  async function normalizeCustomerImage(file) {
    var source = file;
    if (isHeicFile(file)) {
      var convertHeic = await ensureHeicConverter();
      source = await convertHeic({
        blob: file,
        toType: 'image/jpeg',
        quality: CUSTOMER_IMAGE_JPEG_QUALITY
      });
      if (Array.isArray(source)) source = source[0];
      if (!(source instanceof Blob)) throw new Error('HEIC conversion failed');
    }

    var image = await loadCustomerImage(source);
    var sourceWidth = Number(image.naturalWidth || image.width);
    var sourceHeight = Number(image.naturalHeight || image.height);
    if (!Number.isFinite(sourceWidth) || sourceWidth < 1 || !Number.isFinite(sourceHeight) || sourceHeight < 1) {
      throw new Error('The selected image has invalid dimensions');
    }
    var scale = Math.min(1, CUSTOMER_IMAGE_MAX_DIMENSION / Math.max(sourceWidth, sourceHeight));
    var width = Math.max(1, Math.round(sourceWidth * scale));
    var height = Math.max(1, Math.round(sourceHeight * scale));
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    var context = canvas.getContext('2d', { alpha: false });
    if (!context) throw new Error('Canvas is not available');
    context.fillStyle = '#fff';
    context.fillRect(0, 0, width, height);
    context.drawImage(image, 0, 0, width, height);
    return {
      blob: await customerCanvasToJpeg(canvas),
      width: width,
      height: height,
      originalWidth: sourceWidth,
      originalHeight: sourceHeight
    };
  }

  async function readCustomerUploadResponse(response, label) {
    var payload = await response.json().catch(function () { return {}; });
    if (!response.ok) {
      var message = typeof payload.error === 'string' && payload.error
        ? payload.error
        : (typeof payload.errorMessage === 'string' && payload.errorMessage
          ? payload.errorMessage
          : label + ' failed (' + response.status + ')');
      throw new Error(message);
    }
    return payload;
  }

  async function prepareCustomerShopifyUpload(fileSize) {
    var response = await fetchWithTimeout(UPLOAD_PREPARE_API_BASE_URL + '/api/shopify-prepare-upload', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ mime_type: 'image/jpeg', file_size: fileSize || 0 })
    }, REQUEST_TIMEOUT_MS);
    var target = await readCustomerUploadResponse(response, 'Prepare upload');
    if (
      target.fallback === true || typeof target.url !== 'string' || !target.url ||
      typeof target.resourceUrl !== 'string' || !target.resourceUrl ||
      !Array.isArray(target.parameters)
    ) throw new Error('Invalid Shopify staged upload target');
    return target;
  }

  async function uploadCustomerBlobToShopify(target, jpegBlob) {
    var form = new FormData();
    target.parameters.forEach(function (parameter) {
      if (isObject(parameter) && typeof parameter.name === 'string') {
        form.append(parameter.name, parameter.value == null ? '' : String(parameter.value));
      }
    });
    var filename = typeof target.filename === 'string' && target.filename ? target.filename : 'customer.jpg';
    form.append('file', jpegBlob, filename);
    var response = await fetchWithTimeout(target.url, { method: 'POST', body: form }, REQUEST_TIMEOUT_MS);
    if (!response.ok && response.status !== 201) {
      throw new Error('Shopify staged upload failed (' + response.status + ')');
    }
  }

  async function finalizeCustomerShopifyUpload(target) {
    var filename = typeof target.filename === 'string' && target.filename ? target.filename : 'customer.jpg';
    var response = await fetchWithTimeout(SHOPIFY_UPLOAD_API_BASE_URL + '/api/shopify-finalize-upload', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ resource_url: target.resourceUrl, filename: filename })
    }, REQUEST_TIMEOUT_MS);
    var result = await readCustomerUploadResponse(response, 'Finalize upload');
    if (typeof result.url !== 'string' || !result.url) throw new Error('Finalize upload returned no URL');
    return result;
  }

  async function fallbackCustomerShopifyUpload(jpegBlob) {
    var form = new FormData();
    form.append('file', jpegBlob, 'customer.jpg');
    var response = await fetchWithTimeout(API_BASE_URL + '/api/product-template-upload', {
      method: 'POST',
      body: form
    }, REQUEST_TIMEOUT_MS);
    var result = await readCustomerUploadResponse(response, 'Fallback upload');
    if (typeof result.url !== 'string' || !result.url) throw new Error('Fallback upload returned no URL');
    return result;
  }

  async function uploadCustomerImage(file, onStage) {
    onStage = typeof onStage === 'function' ? onStage : function () {};
    onStage('Optimizing image...');
    var earlyTargetPromise = prepareCustomerShopifyUpload(0).catch(function () { return null; });
    var normalized = await normalizeCustomerImage(file);
    console.info('[HavJoy] customer image optimized | ' + normalized.originalWidth + 'x' + normalized.originalHeight +
      ' -> ' + normalized.width + 'x' + normalized.height + ' | ' + Math.round(normalized.blob.size / 1024) + ' KB JPEG');
    var target = await earlyTargetPromise;
    try {
      if (!target) target = await prepareCustomerShopifyUpload(normalized.blob.size);
      onStage('Uploading image...');
      await uploadCustomerBlobToShopify(target, normalized.blob);
      onStage('Finishing upload...');
      var finalized = await finalizeCustomerShopifyUpload(target);
      return {
        url: finalized.url,
        cdn: finalized.cdn || 'shopify',
        width: normalized.width,
        height: normalized.height
      };
    } catch (directUploadError) {
      console.warn('[HavJoy] Direct Shopify customer upload failed; using server fallback', directUploadError);
      onStage('Finishing upload...');
      var fallback = await fallbackCustomerShopifyUpload(normalized.blob);
      return {
        url: fallback.url,
        cdn: fallback.cdn || '',
        width: normalized.width,
        height: normalized.height
      };
    }
  }



  // Only known garment colors get a painted chip; unknown names stay readable.
  // Raw Shopify values are preserved on the option controls.






  function setText(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  function setProp(node, key, value) { if (node && node[key] !== value) node[key] = value; }
  function setAttr(node, key, value) { if (node && node.getAttribute(key) !== value) node.setAttribute(key, value); }
  function setData(node, key, value) { if (node && node.dataset[key] !== value) node.dataset[key] = value; }
  function setDisplay(node, value) { if (node && node.style.display !== value) node.style.display = value; }



  function normalizeProduct(raw, fallback) {
    fallback = fallback || {};
    if (!isObject(raw) || !Array.isArray(raw.variants)) return null;
    var optionNames = Array.isArray(raw.options) ? raw.options.map(function (option) {
      if (typeof option === 'string') return option;
      return isObject(option) && typeof option.name === 'string' ? option.name : '';
    }).filter(Boolean) : [];
    var variants = raw.variants.map(function (variant) {
      if (!isObject(variant) || variant.id == null || !Array.isArray(variant.options)) return null;
      var image = variant.featured_image;
      var imageUrl = typeof image === 'string' ? image : isObject(image) && typeof image.src === 'string' ? image.src : '';
      if (imageUrl.indexOf('//') === 0) imageUrl = 'https:' + imageUrl;
      var imageWidth = isObject(image) ? Number(image.width) : 0;
      var imageHeight = isObject(image) ? Number(image.height) : 0;
      // Ajax product variants may omit dimensions; use that Shopify image's media metadata.
      if (!(imageWidth > 0 && imageHeight > 0) && imageUrl && Array.isArray(raw.media)) {
        var media = raw.media.find(function(item) {
          var preview = item && item.preview_image;
          var src = preview && preview.src || item && item.src || '';
          if (src.indexOf('//') === 0) src = 'https:' + src;
          return src.split('?')[0] === imageUrl.split('?')[0];
        });
        var dimensions = media && (media.preview_image || media);
        imageWidth = dimensions ? Number(dimensions.width) : imageWidth;
        imageHeight = dimensions ? Number(dimensions.height) : imageHeight;
      }
      var featuredImage = /^https:\/\//i.test(imageUrl) && Number.isFinite(imageWidth) && imageWidth > 0 &&
        Number.isFinite(imageHeight) && imageHeight > 0
        ? { id: image.id, src: imageUrl, width: imageWidth, height: imageHeight } : null;
      return {
        id: String(variant.id),
        options: variant.options.map(String),
        price: Number(variant.price) || 0,
        available: variant.available !== false,
        featuredImage: featuredImage
      };
    }).filter(Boolean);
    if (!variants.length) return null;
    return {
      handle: String(raw.handle || raw.product_handle || fallback.handle || ''),
      title: String(raw.title || fallback.title || 'Custom tee'),
      image: String(raw.featured_image || fallback.image || ''),
      options: optionNames,
      variants: variants
    };
  }



  function init(root, previewDriver) {
    if (root && root.closest('[data-wooden-pdp]') && !previewDriver) return;
    if (!root || root.dataset.hjv2Initialized === 'true') return;
    var scope = root.closest('.hj-personalize-scope');
    var collectionFlow = scope && scope.dataset.hjCollectionFlow === 'true';
    function flowIsVisible() {
      return !collectionFlow || (scope.isConnected && scope.dataset.hjCollectionActive === 'true');
    }
    var form = root.closest('form[action*="/cart/add"]');
    var productRoot = scope && scope.querySelector('.hj-tee-product');
    var modal = scope && scope.querySelector('#personalize-modal');
    var fileInput = scope && scope.querySelector('#file-input');
    var productData = parseJsonElement('Hjv2ProductData-' + root.dataset.sectionId);
    if (!scope || !form || !productRoot || !modal || !fileInput || !productData || !Array.isArray(productData.variants)) return;
    var mainProduct = normalizeProduct(productData, {
      handle: productData.product_handle,
      title: productData.title,
      image: productData.featured_image
    });
    if (!mainProduct) return;
    mainProduct.variantBackgroundOnly = scope.hasAttribute('data-pdp-ux');

    var elements = {
      dynamicForm: modal.querySelector('.dynamic-options-form'),
      optionsContainer: modal.querySelector('.product-options-container'),
      confirm: modal.querySelector('.confirm-btn'),
      confirmText: modal.querySelector('.confirm-btn .btn-text'),
      footer: modal.querySelector('.modal-footer'),
      close: modal.querySelector('[data-close]'),
      status: modal.querySelector('.upload-status'),
      statusText: modal.querySelector('.upload-status .status-text'),
      statusBar: modal.querySelector('.upload-status .status-bar'),
      singlePicker: modal.querySelector('[data-single-photo-picker]'),
      singleGrid: modal.querySelector('[data-single-photo-grid]'),
      reuseUpload: modal.querySelector('[data-reuse-upload-note]'),
      cards: modal.querySelector('.img-cards'),
      card: modal.querySelector('.hacard'),
      mainImage: modal.querySelector('.main-image'),
      modalPreview: modal.querySelector('[data-hjv2-modal-preview]'),
      loading: modal.querySelector('.loading-area'),
      note: modal.querySelector('.small-note'),
      designActions: modal.querySelector('.hj-design-actions'),
      atc: productRoot.querySelector('[data-atc-button]'),
      atcText: productRoot.querySelector('[data-atc-text]'),
      atcPrice: productRoot.querySelector('[data-atc-price]'),
      mockupStatus: productRoot.querySelector('[data-tee-mockup-status]'),
      bnpl: productRoot.querySelector('[data-tee-bnpl]'),
      gallery: productRoot.querySelector('.hj-tee-gallery__image'),
      galleryThumbs: productRoot.querySelector('.hj-tee-gallery__thumbs'),
      pdpPreview: productRoot.querySelector('[data-hjv2-pdp-preview]'),
      optionInputs: Array.prototype.slice.call(productRoot.querySelectorAll('[data-hjv2-option-index]')),
      quantity: productRoot.querySelector('[data-tee1-qty]'),
      variantId: form.querySelector('input[name="id"]'),
      live: root.querySelector('[data-hjv2-live]'),
      saving: productRoot.querySelector('[data-tee-saving]'),
      savingText: productRoot.querySelector('[data-tee-saving-text]'),
      atcOriginalPrice: productRoot.querySelector('[data-atc-original-price]'),
      bundleBuilder: productRoot.querySelector('[data-tee-set-builder]'),
      bundleEmpty: productRoot.querySelector('[data-tee-set-empty]'),
      bundleReady: productRoot.querySelector('[data-tee-set-ready]'),
      bundleCards: productRoot.querySelector('[data-tee-set-cards]'),
      bundleCardTemplate: productRoot.querySelector('[data-tee-set-card-template]'),
      bundlePicker: scope.querySelector('[data-tee-set-picker]')
    };
    if (!elements.dynamicForm || !elements.confirm || !elements.mainImage || !elements.atc || !elements.variantId) return;
    root.dataset.hjv2Initialized = 'true';
    if (!elements.mockupStatus) {
      elements.mockupStatus = document.createElement('p');
      elements.mockupStatus.className = 'hj-tee-info__mockup-status caption-small';
      elements.mockupStatus.dataset.teeMockupStatus = '';
      elements.mockupStatus.setAttribute('role', 'status');
      elements.mockupStatus.setAttribute('aria-live', 'polite');
      elements.mockupStatus.hidden = true;
      elements.atc.insertAdjacentElement('afterend', elements.mockupStatus);
    }

    var productTypeOptionIndex = Array.isArray(productData.options)
      ? productData.options.findIndex(function (name) {
        return typeof name === 'string' && name.trim().toLowerCase() === 'product type';
      })
      : -1;

    var state = {
      template: null,
      values: {},
      inputs: {},
      uploadVersions: {},
      uploadsInFlight: 0,
      generation: 0,
      completed: null,
      processing: false,
      addingToCart: false,
      previewUrl: '',
      localPhotoPreviewUrl: '',
      modalStage: 'upload'
    };
    var bundle = {
      slots: [],
      nextId: 2,
      activeSlot: null,
      productCache: {}
    };
    var userAgent = navigator.userAgent || '';
    var isSafari = /AppleWebKit/i.test(userAgent) && /Version\/[\d.]+.*Safari/i.test(userAgent) &&
      !/(Chrome|Chromium|CriOS|Firefox|FxiOS|Edg|EdgiOS|OPiOS|Android)/i.test(userAgent);
    bundle.productCache[mainProduct.handle] = mainProduct;
    var mainOptionControls = productRoot.querySelector('.hj-tee-info__size-qty');



    var deferredCommerce=!collectionFlow && scope.hasAttribute('data-hj-deferred-commerce');
    if(collectionFlow){
      scope.removeAttribute('data-hj-deferred-commerce');
      scope.removeAttribute('data-hj-commerce-state');
      scope.querySelectorAll('[data-hj-commerce-zone]').forEach(function(node){node.hidden=false;});
      var inheritedStatus=scope.querySelector('[data-hj-commerce-status]');
      if(inheritedStatus)inheritedStatus.hidden=true;
    }
    var commerce=null,commercePromise=null,commerceFailed=false;
    function canShop(owner){if(previewDriver?.isDirect && owner===state)return !!(previewDriver.canShop?.() && !owner.editing && !owner.processing && !owner.uploadsInFlight);if(previewDriver)return !!(owner && owner.completed && !owner.editing && !owner.processing && !owner.uploadsInFlight);return !deferredCommerce || !!(owner && owner.completed && owner.completed.designPreview && !owner.editing && !owner.processing && !owner.uploadsInFlight);}
    function updateCommerceGate(){
      if(!deferredCommerce)return;
      var ready=!!commerce && canShop(state);
      scope.dataset.hjCommerceState=ready?'ready':state.completed&&!state.editing?'preparing':'locked';
      scope.querySelectorAll('[data-hj-commerce-zone]').forEach(function(n){n.hidden=!ready;});
      if(!ready)elements.atc.disabled=true;
      var status=scope.querySelector('[data-hj-commerce-status]');
      if(status){
        status.hidden=!(state.completed&&!state.editing&&!commerce);
        status.querySelector('[data-hj-commerce-message]').textContent=commerceFailed?'Shopping options could not load.':'Preparing shopping options…';
        status.querySelector('button').hidden=!commerceFailed;
      }
    }
    function purchaseContext(){return {externalPurchase:previewDriver?.purchase,REQUEST_TIMEOUT_MS,Shopify:window.Shopify,appendTextSuggestions,applyCompletedMockup,bundle,canShop,chooseCompletedMockup,clearError,clearLoadingMessageTimer,closeModal,closeSafariModalBeforePageUpdate,createCompletedResult,elements,fetchWithTimeout,fieldsValid,fileInput,form,hideOverlayPreview,isModalOwner,isSafari,loadPersonalizationTemplate,mainOptionControls,mainProduct,modal,multiPhoto,normalizeProduct,openModal,preserveSafariPagePosition,productData,productRoot,renderFields,resetLoadingVisual,resolveVariantMockup,revokeLocalPhotoPreview,scope,selectedVariant,setAttr,setData,setDisplay,setLive,setLocalPhotoPreview,setMockupStatus,setOverlayPreview,setProp,setStatus,setText,showDetails,showError,showJobError,pendingJobFor,showProcessing,showUploadStep,state,submitGenerationJob,syncBundleGallery,syncMockupGallery,uploadPersonalizationFile,validateField,warmGenerationPreview};}
    function ensureCommerce(){
      if(commerce)return Promise.resolve(commerce);
      if(commercePromise)return commercePromise;
      commerceFailed=false;
      var loading=Promise.resolve().then(function(){
        if(window.HavjoyPurchase && previewDriver)return;
        if(!deferredCommerce && window.HavjoyPurchase)return;
        if(window.HavjoyDeferredAssets)return window.HavjoyDeferredAssets.ensure('purchase');
        // A failed optional bootstrap must not interrupt the already-submitted AI job.
        var original=document.getElementById('HjDeferredRuntime');
        if(!original || !original.src)throw new Error('Shopping loader unavailable. Please retry.');
        return new Promise(function(resolve,reject){
          var script=document.createElement('script');script.src=original.src;
          var timer=setTimeout(function(){script.remove();reject(new Error('Shopping loader timed out'));},20000);
          script.onload=function(){clearTimeout(timer);if(window.HavjoyDeferredAssets)resolve();else reject(new Error('Shopping loader unavailable'));};
          script.onerror=function(){clearTimeout(timer);script.remove();reject(new Error('Shopping loader unavailable'));};
          document.head.appendChild(script);
        }).then(function(){return window.HavjoyDeferredAssets.ensure('purchase');});
      });
      commercePromise=loading.then(function(){
        if(!window.HavjoyPurchase)throw new Error('Shopping options unavailable');
        var instance=window.HavjoyPurchase.create(purchaseContext());instance.init();commerce=instance;
        syncPurchaseSummary();return commerce;
      }).catch(function(error){commercePromise=null;commerceFailed=true;updateCommerceGate();throw error;});
      return commercePromise;
    }
    function beginShoppingLoad(){
      ensureCommerce().catch(function(){});
      if(deferredCommerce && window.HavjoyDeferredAssets)window.HavjoyDeferredAssets.ensure('drawer').catch(function(){});
    }
    function syncPurchaseSummary(){
      if(previewDriver){previewDriver.onState(state);if(commerce)commerce.syncPurchaseSummary();previewDriver.afterState?.();return;}
      warmGenerationPreview(state);bundle.slots.forEach(warmGenerationPreview);
      if(commerce && (!deferredCommerce || state.completed))commerce.syncPurchaseSummary();
      updateCommerceGate();
    }
    function prepareCartItems(){
      if(!commerce || !canShop(state))return Promise.reject(new Error('Generate your artwork before adding to cart.'));
      return commerce.prepareCartItems();
    }
    function syncOptionControls(){return commerce && commerce.syncOptionControls.apply(commerce,arguments);}
function syncVariantFromOptions(){return commerce && commerce.syncVariantFromOptions.apply(commerce,arguments);}
function purchaseSignature(){return commerce && commerce.purchaseSignature.apply(commerce,arguments);}
function mainSourceImageUrl(){return commerce && commerce.mainSourceImageUrl.apply(commerce,arguments);}
function bundleSlotById(){return commerce && commerce.bundleSlotById.apply(commerce,arguments);}
function productVariant(){return commerce && commerce.productVariant.apply(commerce,arguments);}
function bundleSelectedVariant(){return commerce && commerce.bundleSelectedVariant.apply(commerce,arguments);}
function productTypeIndex(){return commerce && commerce.productTypeIndex.apply(commerce,arguments);}
function bundleResolvedMockup(){return commerce && commerce.bundleResolvedMockup.apply(commerce,arguments);}
function bundleCompletedMockup(){return commerce && commerce.bundleCompletedMockup.apply(commerce,arguments);}
function applyBundleCompletedMockup(){return commerce && commerce.applyBundleCompletedMockup.apply(commerce,arguments);}
function cartProperties(){return commerce && commerce.cartProperties.apply(commerce,arguments);}
function primaryCompletedMockup(){return commerce && commerce.primaryCompletedMockup.apply(commerce,arguments);}
function allPurchaseEntries(){return commerce && commerce.allPurchaseEntries.apply(commerce,arguments);}
function bundleReadyForCart(){return commerce && commerce.bundleReadyForCart.apply(commerce,arguments);}
function ordinal(){return commerce && commerce.ordinal.apply(commerce,arguments);}
function appendCardOptions(){return commerce && commerce.appendCardOptions.apply(commerce,arguments);}
function renderBundleCards(){return commerce && commerce.renderBundleCards.apply(commerce,arguments);}
function invalidateBundleSlot(){return commerce && commerce.invalidateBundleSlot.apply(commerce,arguments);}
function renderBundleFields(){return commerce && commerce.renderBundleFields.apply(commerce,arguments);}
function handleBundlePrimaryFile(){return commerce && commerce.handleBundlePrimaryFile.apply(commerce,arguments);}
function fetchBundleProduct(){return commerce && commerce.fetchBundleProduct.apply(commerce,arguments);}
function resolveBundleFlow(){return commerce && commerce.resolveBundleFlow.apply(commerce,arguments);}
function canReuseBundlePhoto(){return commerce && commerce.canReuseBundlePhoto.apply(commerce,arguments);}
function createBundleSlot(){return commerce && commerce.createBundleSlot.apply(commerce,arguments);}
function openBundleSlot(){return commerce && commerce.openBundleSlot.apply(commerce,arguments);}
function openMainSlot(){return commerce && commerce.openMainSlot.apply(commerce,arguments);}
function openBundlePicker(){return commerce && commerce.openBundlePicker.apply(commerce,arguments);}
function closeBundlePicker(){return commerce && commerce.closeBundlePicker.apply(commerce,arguments);}
function removeBundleSlot(){return commerce && commerce.removeBundleSlot.apply(commerce,arguments);}
function syncBundleVariantFromCard(){return commerce && commerce.syncBundleVariantFromCard.apply(commerce,arguments);}
function completeBundleGeneration(){return commerce && commerce.completeBundleGeneration.apply(commerce,arguments);}
function generateBundleV2(){return commerce && commerce.generateBundleV2.apply(commerce,arguments);}
function generateBundleSlot(){return commerce && commerce.generateBundleSlot.apply(commerce,arguments);}
    if(deferredCommerce && !previewDriver){
      scope.querySelector('[data-hj-commerce-status] button')?.addEventListener('click',function(){ensureCommerce().catch(function(){});});
      form.addEventListener('submit',function(event){if(!commerce || !canShop(state)){event.preventDefault();event.stopImmediatePropagation();}},true);
    }

    function setLive(message) {
      if (elements.live) elements.live.textContent = message || '';
    }

    function setMockupStatus(message, status) {
      if (!elements.mockupStatus) return;
      setText(elements.mockupStatus, message || '');
      setProp(elements.mockupStatus, 'hidden', !message);
      if (status) setData(elements.mockupStatus, 'status', status);
      else if ('status' in elements.mockupStatus.dataset) delete elements.mockupStatus.dataset.status;
    }

    function setStatus(message, active) {
      if (elements.statusText) elements.statusText.textContent = message || '';
      if (elements.status) elements.status.classList.toggle('active', !!active);
      if (elements.statusBar) elements.statusBar.style.display = 'none';
      setLive(message);
    }

    function clearError() {
      var error = elements.dynamicForm.querySelector('.hjv2-modal-error');
      if (error) error.remove();
    }

    function showError(message) {
      clearError();
      var error = document.createElement('div');
      error.className = 'hjv2-modal-error';
      error.setAttribute('role', 'alert');
      error.setAttribute('data-help-vi', 'Yêu cầu chưa hoàn tất. Kiểm tra thông báo và thử lại.');
      error.textContent = message;
      elements.dynamicForm.prepend(error);
      if (elements.optionsContainer) elements.optionsContainer.style.display = 'block';
      setLive(message);
      if (scope.hasAttribute('data-pdp-ux') && flowIsVisible()) {
        error.tabIndex = -1;
        error.focus({ preventScroll: true });
        error.scrollIntoView({ block: 'nearest' });
      }
    }

    function setStep(step) {
      var owner = modalOwner();
      modal.dataset.hjv2HasPhoto = String(!!(owner.template && owner.template.slots.some(function (field) { return field.type === 'image'; })));
      modal.querySelectorAll('.hj-step').forEach(function (node) {
        var nodeStep = Number(node.dataset.step);
        node.classList.toggle('active', nodeStep === step);
        node.classList.toggle('done', nodeStep < step);
        var dot = node.querySelector('.hj-step-dot');
        if (dot) dot.innerHTML = nodeStep < step ? '&#10003;' : String(nodeStep);
      });
    }

    function openModal() {
      if(deferredCommerce && modalOwner().completed){modalOwner().editing=true;syncPurchaseSummary();}
      if (collectionFlow) {
        modal.hidden = false;
        productRoot.hidden = true;
        return;
      }
      if (!modal.open) {
        try { modal.showModal(); }
        catch (error) { modal.setAttribute('open', ''); }
      }
      document.documentElement.classList.add('overflow-hidden');
    }

    function releaseModalScroll() {
      document.documentElement.classList.remove('overflow-hidden');
    }

    function releaseModalFocus() {
      var activeElement = document.activeElement;
      if (activeElement && modal.contains(activeElement) && typeof activeElement.blur === 'function') {
        activeElement.blur();
      }
    }

    function closeModal() {
      if (collectionFlow) {
        modal.hidden = true;
        productRoot.hidden = false;
        if (!flowIsVisible()) return;
        productRoot.tabIndex = -1;
        productRoot.focus({ preventScroll: true });
        productRoot.scrollIntoView({ block: 'start' });
        return;
      }
      releaseModalFocus();
      if (modal.open && typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
      releaseModalScroll();
    }

    function closeSafariModalBeforePageUpdate(owner) {
      if (!isSafari || !isModalOwner(owner) || !modal.open) return Promise.resolve(null);
      var position = {
        x: window.scrollX || window.pageXOffset || 0,
        y: window.scrollY || window.pageYOffset || 0
      };
      closeModal();
      return new Promise(function (resolve) {
        window.requestAnimationFrame(function () {
          var hadTabIndex = productRoot.hasAttribute('tabindex');
          var previousTabIndex = productRoot.getAttribute('tabindex');
          productRoot.setAttribute('tabindex', '-1');
          try { productRoot.focus({ preventScroll: true }); }
          catch (error) { productRoot.focus(); }
          if (hadTabIndex) productRoot.setAttribute('tabindex', previousTabIndex);
          else productRoot.removeAttribute('tabindex');
          window.scrollTo(position.x, position.y);
          resolve(position);
        });
      });
    }

    function preserveSafariPagePosition(position) {
      if (!position) return;
      window.requestAnimationFrame(function () {
        window.scrollTo(position.x, position.y);
      });
    }

    function modalOwner() {
      return bundle.activeSlot || state;
    }

    function isModalOwner(owner) {
      return owner === state ? !bundle.activeSlot : bundle.activeSlot === owner;
    }

    function revokeLocalPhotoPreview(owner) {
      if (!owner || typeof owner.localPhotoPreviewUrl !== 'string' || owner.localPhotoPreviewUrl.indexOf('blob:') !== 0) return;
      var localUrl = owner.localPhotoPreviewUrl;
      URL.revokeObjectURL(localUrl);
      owner.localPhotoPreviewUrl = '';
      if (owner.photoPreviewUrl === localUrl) owner.photoPreviewUrl = '';
      if (owner === state && owner.previewUrl === localUrl) owner.previewUrl = '';
    }

    function setLocalPhotoPreview(owner, file) {
      revokeLocalPhotoPreview(owner);
      var localUrl = URL.createObjectURL(file);
      owner.localPhotoPreviewUrl = localUrl;
      owner.photoPreviewUrl = localUrl;
      if (owner === state) owner.previewUrl = localUrl;
      return localUrl;
    }

    var multiPhoto = window.HavjoyMultiPhoto.create({
      upload: uploadCustomerImage, mime: inferMime, error: showError,
      renderPhoto: renderUploadPhoto,
      preloadPhoto: function (url) { loadCustomerPhoto(url).catch(function () {}); },
      pick: function () { fileInput.multiple=true;fileInput.click(); },
      changed: function(owner) {
        if(owner===state){owner.previewUrl=owner.photoPreviewUrl;invalidateResult({keepGallery:true});}
        else invalidateBundleSlot(owner);
        if(isModalOwner(owner)) { renderSinglePhoto();syncUploadConfirmState(owner); }
        syncPurchaseSummary();
      }
    });
    function renderSinglePhoto() {
      var active=modalOwner();fileInput.multiple=multiPhoto.enabled(active);
      if(multiPhoto.render(active,elements.singlePicker,elements.singleGrid,elements.reuseUpload))return;
      elements.singlePicker.classList.add('hj-multi-upload--single');
      elements.singleGrid.classList.add('hj-multi-upload__grid--single');
      var count=elements.singlePicker.querySelector('[data-multi-photo-count]');if(count)count.hidden=true;
      var title=elements.singlePicker.querySelector('.hj-multi-upload__head p');if(title)title.textContent='Add your photo to start';
      var owner = modalOwner();
      var previewUrl = owner.photoPreviewUrl || owner.previewUrl || '';
      if (elements.singlePicker) {
        var pickerHead = elements.singlePicker.querySelector('.hj-multi-upload__head');
        if (pickerHead) pickerHead.hidden = !!previewUrl;
      }
      if (elements.singleGrid) {
        elements.singleGrid.innerHTML = '';
        if (previewUrl) {
          var tile = document.createElement('div');
          tile.className = 'hj-multi-upload__tile';
          renderUploadPhoto(tile, previewUrl, 'Uploaded photo');
          elements.singleGrid.appendChild(tile);
        } else {
          var choosePhoto = document.createElement('button');
          choosePhoto.type = 'button';
          choosePhoto.className = 'hj-multi-upload__tile hj-multi-upload__add';
          choosePhoto.textContent = 'Choose photo';
          choosePhoto.dataset.helpVi = 'Chọn ảnh cho ornament đang chỉnh sửa.';
          choosePhoto.addEventListener('click', function () {
            if (!isModalOwner(owner) || owner.loading || owner.processing) return;
            fileInput.multiple = false;
            fileInput.click();
          });
          elements.singleGrid.appendChild(choosePhoto);
        }
      }
      if (elements.reuseUpload) elements.reuseUpload.hidden = !previewUrl;
    }

    function templateHasDetailFields(template) {
      if (!template || !Array.isArray(template.slots)) return false;
      var primaryImageSeen = false;
      return template.slots.some(function (field) {
        if (field.type !== 'image') return true;
        if (!primaryImageSeen) {
          primaryImageSeen = true;
          return false;
        }
        return true;
      });
    }

    function canAdvanceUpload(owner) {
      if (templateHasDetailFields(owner.template) && owner.uploadsInFlight > 0) {
        if (multiPhoto.enabled(owner)) return (owner.multiPhotos || []).some(function (photo) { return !photo.removed && photo.status !== 'failed'; });
        return !!(owner.localPhotoPreviewUrl || owner.photoPreviewUrl || owner.previewUrl);
      }
      return owner.uploadsInFlight === 0 && (multiPhoto.enabled(owner)
        ? !multiPhoto.message(owner) : !!(owner.photoPreviewUrl || owner.previewUrl));
    }

    function syncUploadConfirmState(owner) {
      if (!owner || !isModalOwner(owner) || !elements.confirm) return;
      if (owner.modalStage === 'upload') {
        elements.confirm.disabled = !canAdvanceUpload(owner);
      } else if (owner.modalStage === 'details') {
        elements.confirm.disabled = owner.uploadsInFlight > 0;
      }
    }

    function showUploadStep() {
      var owner = modalOwner();
      resetLoadingVisual(owner);
      hideOverlayPreview(elements.modalPreview);
      owner.modalStage = 'upload';
      setStep(1);
      if (elements.optionsContainer) elements.optionsContainer.style.display = elements.dynamicForm.querySelector('.hjv2-modal-error') ? 'block' : 'none';
      if (elements.singlePicker) elements.singlePicker.hidden = false;
      renderSinglePhoto();
      if (elements.cards) elements.cards.style.display = 'none';
      if (elements.card) elements.card.style.display = 'none';
      if (elements.mainImage) {
        elements.mainImage.style.display = 'none';
        if (owner.photoPreviewUrl || owner.previewUrl) elements.mainImage.src = owner.photoPreviewUrl || owner.previewUrl;
      }
      if (elements.loading) elements.loading.style.display = 'none';
      if (elements.note) elements.note.style.display = 'none';
      if (elements.designActions) elements.designActions.style.display = 'none';
      if (elements.footer) elements.footer.style.display = '';
      elements.confirm.disabled = !canAdvanceUpload(owner);
      elements.confirm.classList.remove('loading');
      if (elements.confirmText) {
        elements.confirmText.textContent = templateHasDetailFields(owner.template) ? 'Next' : 'Generate My Art';
      }
      if (owner.uploadsInFlight === 0) setStatus('', false);
    }

    function showDetails() {
      var owner = modalOwner();
      var hasPhoto = !!(owner.photoPreviewUrl || owner.previewUrl);
      var hasDetailFields = templateHasDetailFields(owner.template);

      resetLoadingVisual(owner);
      hideOverlayPreview(elements.modalPreview);
      owner.modalStage = 'details';
      setStep(2);
      if (elements.optionsContainer) elements.optionsContainer.style.display = hasDetailFields ? 'block' : 'none';
      if (elements.dynamicForm) elements.dynamicForm.querySelectorAll('.hjv2-suggestions').forEach(function (choices) {
        choices.dispatchEvent(new Event('hjv2-reveal'));
      });
      if (elements.singlePicker) elements.singlePicker.hidden = true;
      if (elements.cards) elements.cards.style.display = 'none';
      if (elements.card) elements.card.style.display = 'none';
      if (elements.mainImage) elements.mainImage.style.display = 'none';
      if (elements.loading) elements.loading.style.display = 'none';
      if (elements.note) elements.note.style.display = 'none';
      if (elements.designActions) elements.designActions.style.display = 'none';
      if (elements.footer) elements.footer.style.display = '';
      elements.confirm.disabled = owner.uploadsInFlight > 0 || submitLocked(owner);
      elements.confirm.classList.remove('loading');
      if (elements.confirmText) elements.confirmText.textContent = 'Generate My Art';
      if (owner.uploadsInFlight === 0) setStatus('', false);
    }

    function clearLoadingMessageTimer(owner) {
      if (owner && owner.loadingMessageTimer) {
        window.clearInterval(owner.loadingMessageTimer);
        owner.loadingMessageTimer = null;
      }
    }

    function resetLoadingVisual(owner) {
      clearLoadingMessageTimer(owner);
      if (!elements.loading) return;
      elements.loading.classList.remove('with-photo');
      elements.loading.style.backgroundImage = '';
      var progress = elements.loading.querySelector('.progress-bar');
      if (progress) progress.style.display = 'none';
    }

    function showProcessing() {
      var owner = modalOwner();
      releaseModalFocus();
      resetLoadingVisual(owner);
      hideOverlayPreview(elements.modalPreview);
      owner.modalStage = 'processing';
      setStep(3);
      if (elements.optionsContainer) elements.optionsContainer.style.display = 'none';
      if (elements.singlePicker) elements.singlePicker.hidden = true;
      if (elements.cards) elements.cards.style.display = 'block';
      if (elements.card) elements.card.style.display = 'block';
      elements.mainImage.style.display = 'none';
      if (elements.loading) {
        var sourcePhoto = owner.photoPreviewUrl || owner.previewUrl || '';
        elements.loading.style.display = 'flex';
        if (sourcePhoto) {
          elements.loading.style.backgroundImage = 'url("' + String(sourcePhoto).replace(/"/g, '%22') + '")';
          elements.loading.classList.add('with-photo');
        }
        var loadingText = elements.loading.querySelector('.loading-text');
        var loadingMessages = [
          'Analyzing your photo...',
          'Sketching the outline...',
          'Adding colors and details...',
          'Our artist is adding the final touches...',
          'Almost done — your portrait is coming to life!'
        ];
        if (loadingText) {
          var messageIndex = 0;
          loadingText.textContent = loadingMessages[messageIndex];
          owner.loadingMessageTimer = window.setInterval(function () {
            if (!isModalOwner(owner)) return;
            messageIndex = Math.min(messageIndex + 1, loadingMessages.length - 1);
            loadingText.textContent = loadingMessages[messageIndex];
          }, 6000);
        }
      }
      if (elements.note) elements.note.style.display = '';
      if (elements.designActions) elements.designActions.style.display = 'none';
      if (elements.footer) elements.footer.style.display = '';
      elements.confirm.disabled = true;
      elements.confirm.classList.add('loading');
      if (elements.confirmText) elements.confirmText.textContent = 'Creating Preview';
      setStatus('', false);
      setLive('Creating your preview…');
      setMockupStatus('Creating your preview…', 'processing');
    }

    function selectedVariant() {
      var id = String(elements.variantId.value || '');
      return mainProduct.variants.find(function (variant) { return String(variant.id) === id; }) || null;
    }





    function mockupByKey(key) {
      return state.template.mockups.find(function (mockup) { return mockup.key === key; }) || null;
    }

    // Injected inside Flow's product owner closure by the guarded theme patch.
    var mockupGallery = null;
    var galleryBlank = null;
    function galleryRows() {
      return window.HavjoyMockupGallery.group(state.template, productData, selectedVariant());
    }
    function syncMockupGallery() {
      if(previewDriver)return;
      if (!state.template || !elements.pdpPreview) return;
      var selected = resolvedMockup(selectedVariant()), rows = galleryRows();
      if (!mockupGallery) {
        var surface = elements.pdpPreview.parentElement;
        mockupGallery = window.HavjoyMockupGallery.mount(surface, surface, function () {
          var current = resolvedMockup(selectedVariant());
          return {rows:state.completed ? galleryRows() : [], key:current && current.key,
            error:elements.pdpPreview.dataset.galleryError === 'true'};
        }, function (key) {
          state.galleryKey = key;
          if (state.completed) applyCompletedMockup();
          else syncMockupGallery();
        }, function () {
          delete elements.pdpPreview.dataset.galleryError;elements.pdpPreview._hjPreviewRequest=null;
          if (state.completed) applyCompletedMockup();
          else syncMockupGallery();
        });
      }
      // Preserve Shopify product photography until a personalized result exists.
      if (!state.completed) {
        if (elements.gallery) elements.gallery.style.display = 'block';
        if (elements.galleryThumbs) elements.galleryThumbs.style.removeProperty('display');
      }
      mockupGallery.render();
    }
    function galleryPreviewReady(entry) {
      var container = entry.slot ? entry.slot.galleryOverlay : (bundle.slots.length && state.galleryOverlay || elements.pdpPreview);
      return !!container && !container.hasAttribute('aria-busy') && container.dataset.galleryError !== 'true';
    }
    function syncBundleGallery(node, entry, overlay, image) {
      var slot=entry.slot || state;
      var product=entry.product;
      function selected() { return slot === state ? selectedVariant() : bundleSelectedVariant(slot); }
      function currentMockup() { return window.HavjoyMockupGallery.choose(slot,product,selected()); }
      function refresh() { if (slot.completed) { if (slot===state) applyCompletedMockup(); else applyBundleCompletedMockup(slot); } else syncPurchaseSummary(); }
      slot.galleryOverlay=overlay;
      if (!slot.template) return;
      if (!node._mockupGallery) {
        node._mockupGallery=window.HavjoyMockupGallery.mount(node, overlay && overlay.parentElement || node, function () {
          var current=currentMockup();
          return {rows:window.HavjoyMockupGallery.group(slot.template,product,selected()),key:current && current.key,
            error:!!(overlay && overlay.dataset.galleryError==='true')};
        },function(key){slot.galleryKey=key;refresh();},function(){
          delete overlay.dataset.galleryError;overlay._hjPreviewRequest=null;
          var current=currentMockup();
          if (slot===state) { elements.pdpPreview._hjPreviewRequest=null;delete elements.pdpPreview.dataset.galleryError; }
          refresh();
        });
      }
      if (!slot.completed && image) {
        var current=currentMockup(), rows=window.HavjoyMockupGallery.group(slot.template,product,selected());
        var backgroundUrl = current && (current.variantBackground ? current.variantBackground.src : current.templateUrl);
        if (backgroundUrl && rows.length>1 && image.getAttribute('src')!==backgroundUrl) image.src=backgroundUrl;
      }
      node._mockupGallery.render();
    }

    function resolvedMockup(variant) {
      return window.HavjoyMockupGallery.choose(state, productData, variant);
    }

    function chooseCompletedMockup() {
      var resolved = resolvedMockup(selectedVariant());
      return resolved && resolved.overlay
        ? { key: resolved.key, url: resolved.overlay.url, mockup: resolved }
        : { key: '', url: '', mockup: null };
    }

    function hideOverlayPreview(container) {
      if (!container) return;
      container._hjPreviewRequest = null;
      container.removeAttribute('aria-busy');
      container.removeAttribute('data-preview-empty');
      var status = container.querySelector('.hj-preview-error');
      if (status) status.remove();
      container.hidden = true;
      var mockupImage = container.querySelector('.hj-v2-preview__mockup');
      var artworkImage = container.querySelector('.hj-v2-preview__artwork');
      if (mockupImage) {
        mockupImage.removeAttribute('src');
        mockupImage.style.removeProperty('transform');
        mockupImage.style.removeProperty('transform-origin');
      }
      if (artworkImage) artworkImage.removeAttribute('src');
      container.style.removeProperty('aspect-ratio');
    }

    function setOverlayPreview(container, mockup, artworkUrl) {
      artworkUrl = window.HavjoyPrintMask.artworkUrl(artworkUrl, mockup);
      return window.HavjoyDesignPreview.render(container, mockup && mockup.overlay, artworkUrl, function () {
        var card = container && container.closest('[data-hjv2-bundle-slot-id]');
        if (card && card._mockupGallery) card._mockupGallery.render();
        else if (container === elements.pdpPreview) syncMockupGallery();
      });
    }

    function applyCompletedMockup() {
      if(previewDriver){previewDriver.selectVariant(elements.variantId.value);syncPurchaseSummary();return;}
      if (!state.completed) return;
      var selected = chooseCompletedMockup();
      if (galleryBlank) galleryBlank.hidden = true;
      if (!selected.url || state.template.mockupKeys.indexOf(selected.key) === -1) {
        hideOverlayPreview(elements.pdpPreview);
        hideOverlayPreview(elements.modalPreview);
        if (elements.gallery) elements.gallery.style.display = 'none';
        syncPurchaseSummary();
        setMockupStatus('Preview is unavailable for this color. Please choose another color.', 'failed');
        return;
      }
      state.previewUrl = selected.url;
      if (isModalOwner(state)) {
        setOverlayPreview(elements.modalPreview, selected.mockup, state.completed.artworkUrl);
        elements.mainImage.style.display = 'none';
      }
      setOverlayPreview(elements.pdpPreview, selected.mockup, state.completed.artworkUrl);
      if (elements.gallery) elements.gallery.style.display = 'none';
      if (elements.galleryThumbs) elements.galleryThumbs.style.display = 'none';
      syncPurchaseSummary();
    }





    function setFieldError(input, message, show) {
      var group = input && input.closest('.form-group');
      var error = group && group.querySelector('.hjv2-field-error');
      if (error) {
        setText(error, show ? message : '');
        setProp(error, 'hidden', !(show && message));
      }
      if (input) setAttr(input, 'aria-invalid', message ? 'true' : 'false');
    }

    function validateField(owner, field, showErrors) {
      var input = owner.inputs[field.key];
      var message = '';
      var value = field.type === 'text' ? (input ? input.value : owner.values[field.key] || '') : owner.values[field.key] || '';
      owner.values[field.key] = value;
      if (multiPhoto.enabled(owner) && field===owner.template.slots.find(function(s){return s.type==='image';}) && multiPhoto.message(owner)) message=multiPhoto.message(owner);
      else if (field.required && !String(value).trim()) message = field.label + ' is required.';
      else if (field.type === 'text' && value && field.minLength !== null && value.length < field.minLength) {
        message = field.label + ' must be at least ' + field.minLength + ' characters.';
      } else if (field.type === 'text' && field.maxLength !== null && value.length > field.maxLength) {
        message = field.label + ' must be no more than ' + field.maxLength + ' characters.';
      }
      if (input && (owner === state || input !== fileInput)) setFieldError(input, message, showErrors);
      return !message;
    }

    function fieldsValid(owner, showErrors) {
      return owner.template.slots.reduce(function (valid, field) {
        return validateField(owner, field, showErrors) && valid;
      }, true);
    }

    function invalidateResult(options) {
      options = options || {};
      state.generation += 1;
      if (state.stopWatchingJob) state.stopWatchingJob();
      clearLoadingMessageTimer(state);
      state.completed = null;
      state.processing = false;
      elements.atc.disabled = true;
      if(previewDriver){previewDriver.invalidate();if(!options.keepMessage)clearError();syncPurchaseSummary();return;}
      hideOverlayPreview(elements.modalPreview);
      hideOverlayPreview(elements.pdpPreview);
      if (elements.gallery) {
        elements.gallery.style.display = 'block';
        if (!options.keepGallery && productData.featured_image) elements.gallery.src = productData.featured_image;
      }
      if (elements.galleryThumbs) elements.galleryThumbs.style.removeProperty('display');
      if (!options.keepMessage) clearError();
      syncPurchaseSummary();
    }

    function appendTextSuggestions(group, input, field) {
      input.placeholder = field.placeholder || '';
      if (field.inputType !== 'text_with_suggestions' || !field.suggestions || !field.suggestions.length) return;
      var choices = document.createElement('div');
      choices.className = 'hjv2-suggestions';
      choices.setAttribute('role', 'group');
      choices.setAttribute('aria-label', field.label + ' suggestions');
      function revealSelected() {
        var selected = choices.querySelector('[aria-pressed="true"]');
        if (!selected || !choices.clientWidth) return;
        var bounds = choices.getBoundingClientRect();
        var item = selected.getBoundingClientRect();
        if (item.left < bounds.left + 4) choices.scrollLeft += item.left - bounds.left - 4;
        else if (item.right > bounds.right - 4) choices.scrollLeft += item.right - bounds.right + 4;
      }
      choices.addEventListener('hjv2-reveal', revealSelected);
      input.addEventListener('focus', revealSelected);
      field.suggestions.forEach(function (value) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'hjv2-suggestions__choice';
        button.textContent = value;
        button.setAttribute('aria-controls', input.id);
        button.setAttribute('aria-pressed', input.value === value ? 'true' : 'false');
        button.addEventListener('click', function () {
          input.value = value;
          input.dispatchEvent(new Event('input', { bubbles: true }));
        });
        choices.appendChild(button);
      });
      input.addEventListener('input', function () {
        Array.prototype.forEach.call(choices.children, function (button) {
          button.setAttribute('aria-pressed', input.value === button.textContent ? 'true' : 'false');
        });
        revealSelected();
      });
      group.appendChild(choices);
    }

    function renderFields() {
      previewDriver?.purchase?.fieldsRendered?.(null, elements.dynamicForm);
      fileInput.multiple = multiPhoto.enabled(state);
      elements.dynamicForm.innerHTML = '';
      state.inputs = {};
      fileInput.accept = state.template.upload.types.join(',');
      var imageIndex = 0;
      state.template.slots.forEach(function (slot, index) {
        var group = document.createElement('div');
        group.className = 'form-group';
        var id = 'Hjv2ModalField-' + root.dataset.sectionId + '-' + index;
        var label = document.createElement('label');
        label.htmlFor = id;
        label.textContent = slot.label + (slot.required ? ' *' : '');
        if (slot.helpVi) label.setAttribute('data-help-vi', slot.helpVi);
        group.appendChild(label);

        var input;
        if (slot.type === 'image') {
          imageIndex += 1;
          if (imageIndex === 1) {
            input = fileInput;
            input.dataset.hjv2SlotKey = slot.key;
            state.inputs[slot.key] = input;
            var imageStatus = document.createElement('span');
            imageStatus.className = 'hjv2-extra-file-status';
            imageStatus.dataset.hjv2PrimaryImageStatus = '';
            imageStatus.textContent = state.values[slot.key] ? 'Image uploaded.' : 'Choose your photo from the upload area.';
            group.appendChild(imageStatus);
            group.hidden = true;
          } else {
            input = document.createElement('input');
            input.type = 'file';
            input.id = id;
            input.accept = state.template.upload.types.join(',');
            input.className = 'hjv2-extra-file';
            input.dataset.hjv2SlotKey = slot.key;
            var status = document.createElement('span');
            status.className = 'hjv2-extra-file-status';
            status.textContent = 'Maximum ' + Math.ceil(state.template.upload.maxBytes / 1048576) + ' MB.';
            group.appendChild(input);
            group.appendChild(status);
            input.addEventListener('change', function () {
              uploadPersonalizationFile(state, slot.key, input.files && input.files[0], status, {
                clearValue: true,
                invalidate: function () { invalidateResult({ keepGallery: true }); }
              });
            });
            state.inputs[slot.key] = input;
          }
        } else {
          input = document.createElement('input');
          input.type = 'text';
          input.id = id;
          input.required = slot.required;
          input.dataset.hjv2SlotKey = slot.key;
          input.value = state.values[slot.key] || '';
          if (slot.minLength !== null) input.minLength = slot.minLength;
          if (slot.maxLength !== null) input.maxLength = slot.maxLength;
          input.addEventListener('input', function () {
            state.values[slot.key] = input.value;
            invalidateResult({ keepGallery: true });
            validateField(state, slot, false);
          });
          group.appendChild(input);
          appendTextSuggestions(group, input, slot);
          state.inputs[slot.key] = input;
        }

        var fieldError = document.createElement('span');
        fieldError.className = 'hjv2-field-error';
        fieldError.hidden = true;
        group.appendChild(fieldError);
        elements.dynamicForm.appendChild(group);
        if (!Object.prototype.hasOwnProperty.call(state.values, slot.key)) state.values[slot.key] = '';
      });
    }

    async function uploadPersonalizationFile(owner, key, file, statusElement, options) {
      options = options || {};
      if (!file && !options.clearValue) return false;
      owner.uploadVersions[key] = (owner.uploadVersions[key] || 0) + 1;
      var uploadVersion = owner.uploadVersions[key];
      if (options.clearValue) owner.values[key] = '';
      if (options.invalidate) options.invalidate();
      if (!file) return false;

      var mime = inferMime(file);
      if (owner.template.upload.types.indexOf(mime) === -1) {
        if (options.primary) revokeLocalPhotoPreview(owner);
        if (isModalOwner(owner)) showError('Please choose a supported image file.');
        return false;
      }
      if (file.size > owner.template.upload.maxBytes) {
        if (options.primary) revokeLocalPhotoPreview(owner);
        if (isModalOwner(owner)) showError('This image is larger than the allowed upload size.');
        return false;
      }

      owner.uploadsInFlight += 1;
      syncUploadConfirmState(owner);
      if (statusElement) statusElement.textContent = 'Optimizing image...';
      if (isModalOwner(owner)) setStatus('Optimizing image...', true);
      try {
        var uploaded = await uploadCustomerImage(file, function (message) {
          if (owner.uploadVersions[key] !== uploadVersion) return;
          if (statusElement) statusElement.textContent = message;
          if (isModalOwner(owner)) setStatus(message, true);
        });
        if (owner.uploadVersions[key] !== uploadVersion) return false;
        saveRecentUploadedUrl(uploaded.url, !!options.primary);
        owner.values[key] = uploaded.url;
        if (options.primary) {
          revokeLocalPhotoPreview(owner);
          owner.photoPreviewUrl = uploaded.url;
          if (owner === state) owner.previewUrl = uploaded.url;
        }
        if (statusElement) statusElement.textContent = file.name + ' uploaded.';
        if (isModalOwner(owner)) setStatus('', false);
        return true;
      } catch (error) {
        if (owner.uploadVersions[key] === uploadVersion) {
          if (options.clearValue) owner.values[key] = '';
          if (options.primary) revokeLocalPhotoPreview(owner);
          if (statusElement) statusElement.textContent = 'Upload failed. Choose the image to try again.';
          if (isModalOwner(owner)) {
            showError('Could not upload this image. Please try again.');
            setStatus('', false);
          }
        }
        return false;
      } finally {
        owner.uploadsInFlight = Math.max(0, owner.uploadsInFlight - 1);
        syncUploadConfirmState(owner);
      }
    }

    async function handlePrimaryFile(file) {
      var slot = state.template.slots.find(function (item) { return item.type === 'image'; });
      if (!slot || !file) return;
      clearError();
      setLocalPhotoPreview(state, file);
      openModal();
      showUploadStep();
      setStatus('Optimizing image...', true);
      var status = elements.dynamicForm.querySelector('[data-hjv2-primary-image-status]');
      await uploadPersonalizationFile(state, slot.key, file, status, {
        clearValue: true,
        primary: true,
        invalidate: function () { invalidateResult({ keepGallery: true }); }
      });
      if (isModalOwner(state) && state.modalStage === 'upload') showUploadStep();
    }

    function createCompletedResult(template, artworkUrl, originalDesignUrl, generation, product) {
      generation = generation || {};
      return {
        artworkUrl: artworkUrl, printSide: generation.printSide, sessionId: generation.sessionId,
        originalDesignUrl: originalDesignUrl || '',
        designPreview: window.HavjoyDesignPreview.snapshot((product || mainProduct).variants, function(variant) {
          return resolveVariantMockup(template, product || mainProduct, variant);
        })
      };
    }

    function complete(data, token) {
      if (token !== state.generation) return Promise.resolve();
      if (!isObject(data) || data.status !== 'completed') return Promise.reject(new Error('Invalid completed response'));
      if (typeof data.artwork_url !== 'string' || !data.artwork_url) {
        return Promise.reject(new Error('Missing completed assets'));
      }

      var originalDesignUrl = typeof data.pre_remove_background_url === 'string'
        ? data.pre_remove_background_url.trim() : '';
      var completedResult = createCompletedResult(state.template, data.artwork_url, originalDesignUrl, data.generation);
      var initialMockup = chooseCompletedMockup();
      if (!initialMockup.mockup || !initialMockup.mockup.overlay) {
        return Promise.reject(new Error('Invalid client overlay template'));
      }

      return Promise.resolve().then(async function () {
        if (token !== state.generation) return;
        clearLoadingMessageTimer(state);
        state.processing = false;
        state.completed = completedResult;
        if(deferredCommerce)ensureCommerce().catch(function(){});
        var ownsModal = isModalOwner(state);
        var safariPosition = null;
        if (ownsModal) {
          resetLoadingVisual(state);
          if (elements.loading) elements.loading.style.display = 'none';
          setStatus('Your preview is ready.', false);
          safariPosition = await closeSafariModalBeforePageUpdate(state);
          if (token !== state.generation) return;
        }
        applyCompletedMockup();
        productRoot.dataset.state = 'after-gen';
        preserveSafariPagePosition(safariPosition);
        if (ownsModal && (!isSafari || collectionFlow)) closeModal();
      });
    }

    // Builds typed errors from HavjoyJobError; plain Errors if the helper is missing.
    function jobError(kind, data, sessionId, status) {
      var helper = window.HavjoyJobError;
      if (!helper) {
        var fallback = new Error('We could not create your preview. Please try again.');
        fallback.publicMessage = fallback.message;
        return fallback;
      }
      if (kind === 'job') return helper.fromJob(data, sessionId);
      if (kind === 'submit') return helper.fromSubmit(status, data);
      return helper.create(kind, { sessionId: sessionId });
    }

    // Shows a job error with Session ID, Copy, and Check status or Contact support.
    // A checkable session is kept so the next confirm reads it instead of POSTing.
    function showJobError(owner, error, token) {
      var helper = window.HavjoyJobError;
      var kind = error && error.jobErrorKind;
      var resumable = !!(helper && helper.canCheckStatus(error) && typeof error.resume === 'function');
      owner.pendingJob = resumable ? { token: token, sessionId: error.sessionId, resume: error.resume } : null;
      if (kind === 'submit_lost') lockAfterSubmitLost(owner);
      if (!isModalOwner(owner)) return;
      showDetails();
      showError((error && error.publicMessage) || 'We could not create your preview. Please try again.');
      if (elements.confirmText) elements.confirmText.textContent = resumable ? 'Check status' : kind ? 'Generate My Art' : 'Try Again';
      var box = elements.dynamicForm.querySelector('.hjv2-modal-error');
      if (!box || !helper || !kind) return;
      var sessionId = error.sessionId || '';
      if (sessionId) {
        var row = document.createElement('div');
        row.className = 'hjv2-modal-error__session';
        var label = document.createElement('span');
        label.textContent = 'Session ID: ' + sessionId;
        var copy = document.createElement('button');
        copy.type = 'button';
        copy.className = 'hjv2-modal-error__copy';
        copy.textContent = 'Copy';
        copy.addEventListener('click', function () {
          if (!navigator.clipboard || !navigator.clipboard.writeText) return;
          navigator.clipboard.writeText(sessionId).then(function () { copy.textContent = 'Copied'; }, function () {});
        });
        row.append(label, ' ', copy);
        box.appendChild(row);
      }
      var actions = document.createElement('div');
      actions.className = 'hjv2-modal-error__actions';
      if (resumable) {
        var check = document.createElement('button');
        check.type = 'button';
        check.className = 'hjv2-modal-error__check';
        check.textContent = 'Check status';
        check.addEventListener('click', function () { elements.confirm.click(); });
        actions.appendChild(check);
      } else if (kind === 'job_failed' || kind === 'submit_lost') {
        var support = document.createElement('a');
        support.className = 'hjv2-modal-error__support';
        support.href = helper.supportHref(sessionId);
        support.textContent = 'Contact support';
        actions.appendChild(support);
      }
      if (actions.childNodes.length) box.appendChild(actions);
    }

    // The lost request may still be running; block an immediate duplicate POST.
    function lockAfterSubmitLost(owner) {
      owner.submitLockUntil = Date.now() + SUBMIT_LOST_LOCK_MS;
      clearTimeout(owner.submitLockTimer);
      owner.submitLockTimer = setTimeout(function () {
        owner.submitLockTimer = null;
        if (isModalOwner(owner) && owner.modalStage === 'details' && !owner.processing) {
          elements.confirm.disabled = owner.uploadsInFlight > 0;
        }
      }, SUBMIT_LOST_LOCK_MS);
    }

    function submitLocked(owner) {
      return !!(owner && owner.submitLockUntil && Date.now() < owner.submitLockUntil);
    }

    function pendingJobFor(owner) {
      var pending = owner && owner.pendingJob;
      return pending && pending.token === owner.generation ? pending : null;
    }

    function watchGenerationJob(config) {
      if (config.owner.stopWatchingJob) config.owner.stopWatchingJob();
      return new Promise(function (resolve, reject) {
        var stopTransport = function () {};
        var settled = false;
        function finish(error, data) {
          if (settled) return;
          settled = true;
          stopTransport();
          window.removeEventListener('pagehide', leave);
          if (config.owner.stopWatchingJob === cancel) config.owner.stopWatchingJob = null;
          if (config.token !== config.owner.generation || !data && !error) return resolve();
          if (error) {
            // The same session can be read again; never POST a new AI job for it.
            if (window.HavjoyJobError && window.HavjoyJobError.canCheckStatus(error)) error.resume = function () { return watchGenerationJob(config); };
            return reject(error);
          }
          var resultUrl = typeof data.result_url === 'string' ? data.result_url.trim() : '';
          if (!resultUrl && typeof data.artwork_url === 'string') resultUrl = data.artwork_url.trim();
          if (!resultUrl) return reject(new Error('Invalid completed response'));
          var originalDesignUrl = typeof data.pre_remove_background_url === 'string'
            ? data.pre_remove_background_url.trim() : '';
          Promise.resolve().then(async function () {
            if (config.token !== config.owner.generation) return;
            if (config.owner.template && config.owner.template.mockups.some(function(m){return m.print_mask;})) {
              var shapeFiles = data.print_artwork_urls;
              if (!shapeFiles || !Object.keys(shapeFiles).length) {
                var response = await fetch(JOB_STATUS_API_BASE_URL.replace(/\/$/, '') + '/check_job_status?sessionId=' + encodeURIComponent(config.sessionId));
                if (!response.ok) throw new Error('Shape print files could not be loaded.');
                shapeFiles = (await response.json()).print_artwork_urls;
              }
              window.HavjoyPrintMask.register(resultUrl, shapeFiles);
              config.owner.template.mockups.forEach(function(m){window.HavjoyPrintMask.artworkUrl(resultUrl,m);});
            }
            return config.onCompleted(resultUrl, config.sessionId, originalDesignUrl,
              { printSide: config.printSide, sessionId: config.sessionId });
          }).then(resolve, reject);
        }
        function cancel() { finish(); }
        // Leaving (or bfcache) keeps the session checkable, so processing never sticks.
        function leave() { finish(jobError('connection', null, config.sessionId)); }
        config.owner.stopWatchingJob = cancel;
        window.addEventListener('pagehide', leave);
        try {
          stopTransport = window.watchHavjoyJob(config.sessionId, {
            apiBase: JOB_STATUS_API_BASE_URL,
            maxWaitMs: POLL_TIMEOUT_MS,
            onUpdate: function (data) {
              if (config.token !== config.owner.generation) return cancel();
              logGenerationTiming(config.label, config.sessionId, config.startedAt, data.status, data.progress);
              if (['completed', 'failed', 'cancelled'].indexOf(data.status) !== -1) return;
              if (!config.isActive || config.isActive()) {
                var progress = Number(data.progress);
                setLive(Number.isFinite(progress)
                  ? 'Creating your preview: ' + Math.max(0, Math.min(100, Math.round(progress))) + '%'
                  : 'Creating your preview…');
              }
            },
            onComplete: function (data) { finish(null, data); },
            onFailed: function (data) { finish(jobError('job', data, config.sessionId)); },
            onConnectionError: function (error) {
              finish(error && error.jobErrorKind ? error : jobError('connection', null, config.sessionId));
            }
          });
          if (settled) stopTransport();
        } catch (error) { finish(error); }
      });
    }
    function warmGenerationPreview(owner) {
      if (!owner.processing || owner.previewPreparationToken !== owner.generation) return;
      var product = owner === state ? mainProduct : owner.product;
      var variant = owner === state ? selectedVariant() : bundleSelectedVariant(owner);
      var mockup = resolveVariantMockup(owner.template, product, variant);
      var url = mockup && mockup.overlay && mockup.overlay.url;
      if (!url || owner.preparedBackgroundUrl === url) return;
      owner.preparedBackgroundUrl = url;
      // Shares the decoded image promise with render(); never blocks the AI job.
      window.HavjoyDesignPreview.preloadBackground(url);
    }
    async function submitGenerationJob(config) {
      var values = {};
      config.template.slots.forEach(function (field) { values[field.key] = config.owner.values[field.key] || ''; });
      var startedAt = performance.now();
      var generationRequest = fetchWithTimeout(GENERATION_API_BASE_URL + '/tshirt-various-mockup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ product_handle: config.productHandle, values: values, source: 'shopify' })
      }, REQUEST_TIMEOUT_MS);
      beginShoppingLoad();
      var response, data = null;
      // A lost or unreadable answer does not prove the AI never started.
      try { response = await generationRequest; } catch (error) { if (config.token !== config.owner.generation) return; throw jobError('submit_lost'); }
      try { data = await response.json(); } catch (error) { data = null; }
      if (config.token !== config.owner.generation) return;
      var sessionId = isObject(data) && typeof data.session_id === 'string' ? data.session_id.trim() : '';
      var accepted = response.status === 202 && isObject(data) && data.submitted === true && sessionId;
      if (!accepted) {
        var error = jobError('submit', data, '', response.status);
        if (sessionId) error.sessionId = sessionId;
        throw error;
      }
      var printSide = data.print_side === undefined ? 'front' : data.print_side;
      if (['front', 'back'].indexOf(printSide) === -1 || printSide !== config.template.printSide) {
        throw new Error('Print side changed. Please reload this product and try again.');
      }
      var watching = watchGenerationJob(Object.assign({}, config, {
        printSide: printSide,
        sessionId: sessionId,
        startedAt: startedAt
      }));
      // Observe failures immediately while preparing the local preview metadata.
      watching.catch(function () {});
      try {
        if (!applyTshirtVariousMockups(config.template, data.mockups, data.render_canvas, data)) {
          throw new Error('The preview service returned invalid mockup data. Please try again.');
        }
        config.owner.previewPreparationToken = config.token;
        config.owner.preparedBackgroundUrl = '';
        warmGenerationPreview(config.owner);
      } catch (error) {
        if (config.owner.stopWatchingJob) config.owner.stopWatchingJob();
        throw error;
      }
      return watching.finally(function () {
        if (config.owner.previewPreparationToken === config.token) config.owner.previewPreparationToken = null;
      });
    }

    async function generate() {
      // One AI job at a time; a second POST would orphan the running one.
      if (state.processing || submitLocked(state)) return;
      clearError();
      var pending = pendingJobFor(state);
      if (!pending) {
        if (state.uploadsInFlight > 0) { showError('Please wait for your image to finish uploading.'); return; }
        if (!fieldsValid(state, true)) { showError('Please complete the required fields.'); return; }
        var variant = selectedVariant();
        if (!variant || (!variant.available && !previewDriver?.previewSoldOut)) { showError('Please choose an available size.'); return; }
        invalidateResult({ keepGallery: true, keepMessage: true });
      }
      state.pendingJob = null;
      var token = state.generation;
      state.processing = true;
      syncPurchaseSummary();
      if (!previewDriver?.isDirect) showProcessing();

      try {
        if(previewDriver){
          if(pending)await pending.resume();
          else await previewDriver.generate({values:Object.assign({},state.values),template:state.template,isCurrent:function(){return token===state.generation;}});
          if(token!==state.generation)return;
          clearLoadingMessageTimer(state);resetLoadingVisual(state);state.processing=false;state.completed={external:true};
          await ensureCommerce();
          closeModal();syncPurchaseSummary();return;
        }
        if (pending) { await pending.resume(); return; }
        await submitGenerationJob({
          owner: state,
          template: state.template,
          productHandle: productData.product_handle,
          token: token,
          label: 'main generation',
          isActive: function () { return isModalOwner(state); },
          onCompleted: function (artworkUrl, sessionId, originalDesignUrl, generation) {
            return complete({
              status: 'completed',
              generation: generation,
              artwork_url: artworkUrl,
              pre_remove_background_url: originalDesignUrl
            }, token);
          }
        });
      } catch (error) {
        if (token !== state.generation) return;
        clearLoadingMessageTimer(state);
        state.processing = false;
        syncPurchaseSummary();
        if (previewDriver?.isDirect) previewDriver.directError(error);
        else showJobError(state, error, token);
      }
    }

    function handleConfirm() {
      if (previewDriver?.isDirect && !bundle.activeSlot) {
        if (!state.processing) generate();
        return;
      }
      var owner = modalOwner();
      if (owner.modalStage === 'upload' && templateHasDetailFields(owner.template) && canAdvanceUpload(owner)) {
        showDetails();
        return;
      }
      if (multiPhoto.enabled(modalOwner()) && multiPhoto.message(modalOwner())) {showError(multiPhoto.message(modalOwner()));return;}
      if (bundle.activeSlot) {
        var active = bundle.activeSlot;
        if (active.loading || active.processing || !active.template || submitLocked(active)) return;
        if (active.modalStage === 'upload') {
          if (active.uploadsInFlight > 0) {
            setStatus('Please wait for your image to finish uploading.', true);
            return;
          }
          var image = active.template.slots.find(function (field) { return field.type === 'image'; });
          var hasPhoto = !image || !image.required || !!active.values[image.key];
          if (!hasPhoto) {
            setStatus('Please upload your photo to continue.', true);
            return;
          }
          if (templateHasDetailFields(active.template)) showDetails();
          else generateBundleSlot(active);
          return;
        }
        if (active.modalStage === 'details') generateBundleSlot(active);
        return;
      }
      if (state.modalStage === 'upload') {
        if (state.uploadsInFlight > 0) {
          setStatus('Please wait for your image to finish uploading.', true);
          return;
        }
        var primaryImage = state.template.slots.find(function (slot) { return slot.type === 'image'; });
        if (primaryImage && primaryImage.required && !state.values[primaryImage.key]) {
          setStatus('Please upload your photo to continue.', true);
          return;
        }
        if (templateHasDetailFields(state.template)) showDetails();
        else generate();
        return;
      }
      if (state.modalStage === 'details') generate();
    }

    function bindActiveUi() {
      var firstImageSlot = state.template.slots.find(function (slot) { return slot.type === 'image'; });
      fileInput.accept = state.template.upload.types.join(',');
      fileInput.multiple = multiPhoto.enabled(state);

      scope.addEventListener('click', function (event) {
        var uploadTrigger = event.target.closest('.upload-trigger');
        if (uploadTrigger) {
          event.preventDefault();
          if (uploadTrigger.dataset.hjv2BundleSlotId === 'main') {
            openMainSlot();
            return;
          }
          if (uploadTrigger.dataset.hjv2BundleSlotId) {
            var editSlot = bundleSlotById(uploadTrigger.dataset.hjv2BundleSlotId);
            if (editSlot) openBundleSlot(editSlot);
            return;
          }
          bundle.activeSlot = null;
          fileInput.multiple=multiPhoto.enabled(state);
          if (state.processing) {
            // Reopen the running job instead of the upload step.
            openModal();
            showProcessing();
          } else if (state.completed) {
            renderFields();
            openModal();
            if (firstImageSlot) showUploadStep();
            else showDetails();
          } else if (firstImageSlot && state.values[firstImageSlot.key]) {
            openModal();
            showUploadStep();
          } else if (firstImageSlot) {
            fileInput.click();
          } else {
            openModal();
            showDetails();
          }
          return;
        }

        var thumb = event.target.closest('.hj-tee-gallery__thumb');
        if (thumb && elements.gallery && thumb.dataset.imageSrc) {
          productRoot.querySelectorAll('.hj-tee-gallery__thumb').forEach(function (item) { item.classList.toggle('is-active', item === thumb); });
          elements.gallery.src = thumb.dataset.imageSrc;
        }
      });

      fileInput.addEventListener('change', function () {
        var owner=modalOwner();
        if(multiPhoto.enabled(owner)){
          clearError();openModal();showUploadStep();
          multiPhoto.add(owner,fileInput.files);fileInput.value='';return;
        }
        var file = fileInput.files && fileInput.files[0];
        if (file) {
          if (bundle.activeSlot) handleBundlePrimaryFile(bundle.activeSlot, file);
          else handlePrimaryFile(file);
        }
        fileInput.value = '';
      });
      elements.confirm.addEventListener('click', handleConfirm);
      if (elements.reuseUpload) elements.reuseUpload.addEventListener('click', function () { fileInput.click(); });
    }

    // Preserve Shopify's selected variant (including links with ?variant=).
    if(deferredCommerce && !selectedVariant()){
      var initialVariant=mainProduct.variants.find(function(v){return v.available;});
      if(initialVariant)elements.variantId.value=String(initialVariant.id);
    }
    var pendingPhoto = null;
    function pickBeforeTemplate(event) {
      if (!event.target.closest('.upload-trigger')) return;
      event.preventDefault();
      fileInput.click();
    }
    function queueBeforeTemplate() {
      var file = fileInput.files && fileInput.files[0];
      if (!file) return;
      pendingPhoto = file;
      fileInput.value = '';
      setLive('Photo selected. Preparing personalization options…');
    }
    function stopEarlyPicker() {
      scope.removeEventListener('click', pickBeforeTemplate);
      fileInput.removeEventListener('change', queueBeforeTemplate);
      delete scope.dataset.hjEarlyPicker;
    }
    async function bootstrap() {
      scope.dataset.hjV2State = 'checking';
      if (!collectionFlow) {
        fileInput.accept = DEFAULT_IMAGE_TYPES.join(',');
        fileInput.multiple = false;
        scope.addEventListener('click', pickBeforeTemplate);
        fileInput.addEventListener('change', queueBeforeTemplate);
        scope.dataset.hjEarlyPicker = 'true';
      }
      try {
        var template = previewDriver ? await previewDriver.template() : await loadPersonalizationTemplate(productData.product_handle, mainProduct);
        state.template = template;
        multiPhoto.restore(state);
        var restoredUploadUrl = multiPhoto.enabled(state) ? '' : readLatestUploadedUrl();
        var primaryImageSlot = template.slots.find(function (slot) { return slot.type === 'image'; });
        if (restoredUploadUrl && primaryImageSlot && !state.values[primaryImageSlot.key]) {
          state.values[primaryImageSlot.key] = restoredUploadUrl;
          state.photoPreviewUrl = restoredUploadUrl;
          state.previewUrl = restoredUploadUrl;
          loadCustomerPhoto(restoredUploadUrl).catch(function () {});
        }
        renderFields();
        stopEarlyPicker();
        bindActiveUi();
        if (previewDriver?.isDirect) {previewDriver.directMount({state:state,elements:elements,invalidate:invalidateResult,confirm:generate});await ensureCommerce();}
        elements.optionInputs.forEach(function (input) {
          if (input.getAttribute('name') === 'properties[Size Tee 1]') input.removeAttribute('name');
        });
        scope.dataset.hjV2State = 'active';
        elements.atc.disabled = true;
        syncPurchaseSummary();
        if ('ornamentStartup' in scope.dataset) scope.dataset.ornamentStartup = 'ready';
        if (pendingPhoto) {
          var queuedPhoto = pendingPhoto;
          pendingPhoto = null;
          if (primaryImageSlot) {
            if (multiPhoto.enabled(state)) {
              clearError();openModal();showUploadStep();
              multiPhoto.add(state, [queuedPhoto]);
            } else {
              handlePrimaryFile(queuedPhoto);
            }
          } else {
            openModal();showDetails();
            showError('This product does not accept a photo. Please review the personalization options.');
          }
        }
        if (collectionFlow) {
          // Text-only ornaments own an inline form and live preview on the product panel.
          if (previewDriver?.isDirect) closeModal();
          else {
            openModal();
            if (primaryImageSlot) showUploadStep();
            else showDetails();
          }
        }
      } catch (error) {
        if ('ornamentStartup' in scope.dataset) scope.dataset.ornamentStartup = 'error';
        stopEarlyPicker();
        var hadPendingPhoto = !!pendingPhoto;
        pendingPhoto = null;
        if (collectionFlow) {
          scope.dispatchEvent(new CustomEvent('havjoy:pdp-unavailable', { bubbles: true }));
          return;
        }
        scope.dataset.hjV2State = 'active';
        elements.atc.disabled = true;
        if (collectionFlow) {
          openModal();
          showDetails();
          elements.confirm.disabled = true;
          if (elements.optionsContainer) elements.optionsContainer.style.display = 'block';
          showError('Personalization options are unavailable for this product. Please try again later.');
        }
        scope.addEventListener('click', function (event) {
          var trigger = event.target.closest('.upload-trigger');
          if (!trigger) return;
          event.preventDefault();
          elements.dynamicForm.innerHTML = '';
          openModal();
          showDetails();
          elements.confirm.disabled = true;
          if (elements.optionsContainer) elements.optionsContainer.style.display = 'block';
          showError('Personalization options are unavailable for this product. Please try again later.');
        });
        if (hadPendingPhoto) {
          openModal();showDetails();elements.confirm.disabled = true;
          if (elements.optionsContainer) elements.optionsContainer.style.display = 'block';
          showError('Personalization options are unavailable for this product. Please try again later.');
        }
      }
    }

    // Closing must remain available even when API configuration cannot load.
    if (elements.close) elements.close.addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) { if (event.target === modal) closeModal(); });
    modal.addEventListener('cancel', releaseModalFocus);
    modal.addEventListener('close', releaseModalScroll);
    modal.addEventListener('close',function(){state.editing=false;bundle.slots.forEach(function(slot){slot.editing=false;});syncPurchaseSummary();});
    if(previewDriver){previewDriver.refreshPurchase=syncPurchaseSummary;}
    if(!deferredCommerce && !previewDriver){commerce=window.HavjoyPurchase.create(purchaseContext());commerce.init();}
    if(previewDriver)window.addEventListener('pagehide',function(){clearLoadingMessageTimer(state);revokeLocalPhotoPreview(state);state.generation+=1;bundle.slots.forEach(function(slot){slot.generation+=1;if(slot.stopWatchingJob)slot.stopWatchingJob();});},{once:true});
    bootstrap();
  }

  // Collection hosts mount the same controller, without copying purchase logic.
  window.HavjoyTemplateFlowV2 = { init: init, normalizeTemplate: normalizeTemplate };
  document.querySelectorAll('[data-hjv2-root]').forEach(function(root){init(root);});
})();
